// const SIZE_ORDER = ["XXS", "XS", "S", "M", "L/XL", "L", "XL", "XXL", "3XL", "4XL", "5XL", "6XL"];
// function sortProductSwatches() {
//     function getSortValue(btn) {
//         const rawText =
//             (btn.dataset.variantText || btn.textContent || "")
//                 .toUpperCase()
//                 .replace(/\s+/g, " ")
//                 .trim();

//         /* ---------- SIZE SORT ---------- */
//         if (SIZE_ORDER.includes(rawText)) {
//             return SIZE_ORDER.indexOf(rawText);
//         }

//         // 3XL, 4XL, 5XL...
//         const xlMatch = rawText.match(/^(\d+)XL$/);
//         if (xlMatch) {
//             return SIZE_ORDER.length + parseInt(xlMatch[1], 10);
//         }

//         /* ---------- WEIGHT SORT (G / KG) ---------- */
//         const weightMatch = rawText.match(/(\d+(\.\d+)?)\s*(KG|G)\b/);
//         if (weightMatch) {
//             let value = parseFloat(weightMatch[1]);
//             if (weightMatch[3] === "KG") value *= 1000; // normalize to grams
//             return value;
//         }

//         /* ---------- LENGTH SORT (MM / CM / M) ---------- */
//         const lengthMatch = rawText.match(/(\d+(\.\d+)?)\s*(MM|CM|M)\b/);
//         if (lengthMatch) {
//             let value = parseFloat(lengthMatch[1]);
//             const unit = lengthMatch[3];

//             // normalize everything to millimeters
//             if (unit === "CM") value *= 10;
//             if (unit === "M") value *= 1000;

//             return value;
//         }

//         /* ---------- PACK SORT ---------- */
//         const packMatch = rawText.match(/\bPACK OF\s*(\d+)/);
//         if (packMatch) {
//             return parseInt(packMatch[1], 10);
//         }

//         /* ---------- FALLBACK ---------- */
//         const numMatch = rawText.match(/\d+(\.\d+)?/);
//         if (numMatch) {
//             return parseFloat(numMatch[0]);
//         }

//         return Number.MAX_SAFE_INTEGER;
//     }

//     document.querySelectorAll(".CLS_optionsItems").forEach(group => {
//         const buttons = Array.from(
//             group.querySelectorAll("button.singleOptionBtn")
//         );

//         if (buttons.length < 2) return;

//         buttons
//             .sort((a, b) => getSortValue(a) - getSortValue(b))
//             .forEach(btn => group.appendChild(btn));
//     });
// }


// function getValueFromNestedAttr(attr) {
//     if (attr.nestedValues) {
//         return attr.nestedValues;
//     } else {
//         return attr.values;
//     }
// }

// if (window.location.pathname === '/') {
//     document.body.classList.add('wz-home-page');
//     $(window).scroll(function () {
//         var scroll = $(window).scrollTop();
//         if (scroll >= 100) {
//             $("body").addClass("wz-scroll");
//         }
//         else {
//             $("body").removeClass("wz-scroll");
//         }
//     });
// }
// else {
//     document.body.classList.remove('wz-home-page');
// }
// const storageKey = "pageHistory";
// const currentPage = window.location.href;

// let pageHistory = JSON.parse(localStorage.getItem(storageKey)) || [];

// if (!pageHistory.length || pageHistory[pageHistory.length - 1] !== currentPage) {
//     pageHistory.push(currentPage);
//     localStorage.setItem(storageKey, JSON.stringify(pageHistory));
// }
// $(".gobackhistory").on("click", function (e) {
//     e.preventDefault();

//     pageHistory.pop();
//     const previousPage = pageHistory.pop();

//     if (previousPage) {
//         localStorage.setItem(storageKey, JSON.stringify(pageHistory));
//         window.location.href = previousPage;
//     } else {
//         window.location.href = "/";
//     }
// });

// function isSearchPage() {
//     return window.location.pathname.includes("/search");
// }

// function getQueryFromURL() {
//     const params = new URLSearchParams(window.location.search);
//     return params.get("q") || "";
// }

// if (window.innerWidth <= 1024) {
//     (function () {
//         const bodyEndWrapper = document.querySelector(".wizzy-body-end-wrapper");

//         if (!bodyEndWrapper) return;

//         let timeout = null;

//         function handleToggle() {
//             if (document.body.classList.contains("wizzyMobileTapped")) {
//                 clearTimeout(timeout);
//                 timeout = setTimeout(() => {
//                     bodyEndWrapper.style.display = "block";
//                 }, 500);
//             } else {
//                 clearTimeout(timeout);
//                 bodyEndWrapper.style.display = "none";
//             }
//         }
//         handleToggle();
//         const observer = new MutationObserver(handleToggle);
//         observer.observe(document.body, {
//             attributes: true,
//             attributeFilter: ["class"]
//         });
//     })();


//     const searchIcon = document.querySelectorAll('.MSH_searchOuter button, .MSH_searchIconOuter .MSH_newIcons');
//     const searchInput2 = document.querySelector("#search_mini_form .input-text");
//     const backButton = document.querySelector("#search_mini_form .wizzy-search-back");

//     if (searchIcon) {
//         searchIcon.forEach(icon => {
//         icon.addEventListener("click", () => {
//             if (!searchInput2) return;
//                 searchInput2.value = "";
//                 // Must not defer: mobile browsers only associate the keyboard with focus that
//                 // runs in the same turn as the user's tap; setTimeout breaks that chain.
//                 searchInput2.click();
//                 if (searchFormWrapper && document.body.classList.contains("wizzyMobileTapped")) {
//                     searchFormWrapper.classList.add("wizzy-search-drawer-open");
//                     searchInput2.focus({ preventScroll: true });
//                 }
//             });
//         });
//     }

//     if (searchInput2 && backButton) {
//         searchInput2.addEventListener("keydown", function (e) {
//             if (e.key === "Enter" && isSearchPage()) {
//                 const inputValue = this.value.trim();
//                 const urlQuery = getQueryFromURL().trim();
//                 if (inputValue && inputValue === urlQuery) {
//                     backButton.click();
//                 }
//             }
//         });
//     }

//     if (searchInput2) {
//         searchInput2.addEventListener("input", function () {
//             if (this.value === "") {
//                 searchInput2.click();
//             }
//         });

//         searchInput2.addEventListener("keydown", function (e) {
//             if (e.key === "Backspace" && this.value === "") {
//                 searchInput2.click();
//             }
//         });
//     }
// } else {
//     // document.addEventListener("click", function (e) {
//     //     const clearIcon = e.target.closest(".wz-autocomplete-cross-icon");
//     //     const searchInput = document.querySelector(".wz-search-bar.wz-for-desktop .wz-search-input");

//     //     if (clearIcon && searchInput) {
//     //         searchInput.value = "";
//     //         searchInput.dispatchEvent(new Event("input", { bubbles: true }));
//     //         searchInput.focus();
//     //     }
//     // });
//     document.addEventListener(
//   "mousedown",
//   function (e) {
//     const clearIcon = e.target.closest(".wz-autocomplete-cross-icon");
//     if (!clearIcon) return;

//     const searchInput = document.querySelector(
//       ".wz-search-bar.wz-for-desktop .wz-search-input"
//     );

//     if (searchInput) {
//       e.preventDefault(); // prevents blur issue
//       e.stopPropagation(); // avoid interference

//       searchInput.value = "";
//       searchInput.dispatchEvent(new Event("input", { bubbles: true }));
//       searchInput.focus();
//     }
//   },
//   true // 👈 capture phase (VERY IMPORTANT)
// );
// }

// (function setupWizzyMobileSearchDrawerSlideIn() {
//     function isMobileSearchBreakpoint() {
//         if(window.innerWidth <= 1024) {
//             return true;
//         }
//         return false;
//     }

//     function bind() {
//         const wrapper = document.querySelector(".wizzy-search-form-wrapper");
//         if (!wrapper || wrapper.dataset.wizzyDrawerSlideBound === "1") return;
//         if (!wrapper.querySelector(".wizzy-search-form")) return;
//         wrapper.dataset.wizzyDrawerSlideBound = "1";

//         function queueSlideOpen() {
//             if (!isMobileSearchBreakpoint() || !document.body.classList.contains("wizzyMobileTapped")) {
//                 return;
//             }
//             // wrapper.classList.remove("wizzy-search-drawer-open");
//             // void wrapper.offsetWidth;
//             // requestAnimationFrame(function () {
//             //     requestAnimationFrame(function () {
//             //         if (document.body.classList.contains("wizzyMobileTapped") && isMobileSearchBreakpoint()) {
//             //             wrapper.classList.add("wizzy-search-drawer-open");
//             //         }
//             //     });
//             // });
//             wrapper.classList.add("wizzy-search-drawer-open");
//         }

//         function syncDrawerFromBody() {
//             if (!isMobileSearchBreakpoint()) {
//                 wrapper.classList.remove("wizzy-search-drawer-open");
//                 return;
//             }
//             if (document.body.classList.contains("wizzyMobileTapped")) {
//                 if (!wrapper.classList.contains("wizzy-search-drawer-open")) {
//                     queueSlideOpen();
//                 }
//             } else {
//                 wrapper.classList.remove("wizzy-search-drawer-open");
//             }
//         }

//         const observer = new MutationObserver(syncDrawerFromBody);
//         observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
//         window.addEventListener("resize", syncDrawerFromBody);

//         syncDrawerFromBody();
//     }

//     if (document.readyState === "loading") {
//         document.addEventListener("DOMContentLoaded", bind);
//     } else {
//         bind();
//     }
// })();


// function closeSearchDrawer() {
//     const closeBtn = document.querySelector(".wizzy-search-form .wizzy-search-back");
//     if (closeBtn) {
//         closeBtn.click();
//     }
// }

// if(window.innerWidth <= 1024) {
//     window.addEventListener("load", closeSearchDrawer);
//     window.addEventListener("pageshow", function (event) {
//         if (event.persisted) {
//             closeSearchDrawer();
//         }
//     });
// }


// window.onWizzyScriptLoaded = function () {

//     const searchBar = document.querySelectorAll(".wz-search-bar .wz-search-input");
//     searchBar.forEach((sbar) => {
//         sbar.addEventListener("click", () => {
//             setTimeout(() => {
//                 let autoCompleteArrows = document.querySelectorAll(".autocomplete-text-wrapper");
//                 if (autoCompleteArrows) {
//                     autoCompleteArrows.forEach((arrow) => {
//                         if (arrow) {
//                             arrow.addEventListener("click", () => {
//                                 sbar.value = arrow.parentElement.getAttribute("data-searchterm");
//                                 sbar.focus();
//                             });
//                         }
//                     });
//                 }
//             }, 300)
//         });
//     });

//     // const targetNode = document.querySelector(".wizzy-body-end-wrapper");
//     // function updateBodyClass() {
//     //     const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
//     //     autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
//     // }
//     // const config = {
//     //     childList: !0,
//     //     subtree: !0,
//     //     attributes: !0,
//     //     attributeFilter: ["style"]
//     // }
//     //     , callback = function (mutationsList, observer2) {
//     //         for (const mutation of mutationsList) {
//     //             updateBodyClass();
//     //             break
//     //         }
//     //     }
//     //     , observer = new MutationObserver(callback);
//     // targetNode && (observer.observe(targetNode, config),
//     //     updateBodyClass());



//     // let lastScrollTop = 0;
//     // function handleScroll() {
//     //     const currentScrollTop = $(window).scrollTop();
//     //     if (currentScrollTop >= 100) {
//     //         $(".wz-filters-list-top-wrapper").addClass("fixedplp_top_rsidebar");
//     //         $("body").addClass("wz-scroll");
//     //     } else {
//     //         $(".wz-filters-list-top-wrapper").removeClass("fixedplp_top_rsidebar");
//     //         $("body").removeClass("wz-scroll");
//     //     }

//     //     if (currentScrollTop < lastScrollTop && currentScrollTop > 200) {
//     //         $(".wz-filters-list-top-wrapper").addClass("filter_menu_top");
//     //     } else {
//     //         $(".wz-filters-list-top-wrapper").removeClass("filter_menu_top");
//     //     }
//     //     lastScrollTop = currentScrollTop;
//     // }


//     // $(window).on("scroll", handleScroll);
//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
//         function (data) {

//             window.wizzyConfig.gridFilters.enabled = false;
//             window.wizzyConfig.common.view.templates.literals.sortBy = "Sort";
//             // window.wizzyConfig.credentials = {
//             //     "apiKey": "Z1UvQTZ6VEcrdTBVZ05rYmNGUVBWOWNrREt3NTNERmN2VmU1ZnVLYWx6SGptdTlDRjJodStESjhTeXNYVTVhczdKVld1WDV3TU5aWVBneHdzcnZnUU8vUG55SFZkUXFtT25xS00zc3NhMzA9",
//             //     "storeId": "6526f806b3c511f092560a0c8095feae"
//             // };

//             // dev store credentials
//             // data.credentials = {
//             //     "apiKey": "c1FNWE5HN2lTKzQ5enlUanVTZzVSOG14aGExeDFLbzNGZHR0UGRPT3Jxb0t0NDJDWFdVa2JVN251QklyamlUUDlKT3Zpd1Q3WlFQOW1CQ0Q5ajMxUHB6bWp6ZVRGcGxSNGhZNHI5WXI1cVk9",
//             //     "storeId": "33381c500af811f19e330a0c8095feae"
//             // };

//             data.filters.configs.keepOpenedInMobileAfterApply = true;
//             if (window.innerWidth > 1024) {
//                 data.common.lazyDOMConfig.searchInputIdentifiers = [
//                     {
//                         dom: ".wz-search-bar.wz-for-desktop .wz-search-input",
//                         type: "text"
//                     }
//                 ]
//             }
//             else {
//                 data.common.lazyDOMConfig.searchInputIdentifiers = [
//                     {
//                         dom: "#search_mini_form .input-text",
//                         type: "text"
//                     }
//                 ]
//             }
//             window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
//                 desktop: 6e3,
//                 mobile: 10e3,
//             };
//             data.filters.configs.layout = "v1";
//             window.wizzyConfig.search.configs.pagination.appendInExistingList = "true";

//             try {
//                 window.wizzyConfig.search.view.templates.facets.rangeListItem =
//                     "#wizzy-facet-range-list-item";
//                 window.wizzyConfig.search.configs.facets.configs =
//                     window.wizzyConfig.search.configs.facets.configs.filter(
//                         (facet) => facet.key !== "sellingPrice"
//                     );
//                 window.wizzyConfig.search.configs.facets.configs.push({
//                     label: "Price",
//                     buckets: [
//                         {
//                             from: 0,
//                             to: 300,
//                         },
//                         {
//                             from: 300,
//                             to: 500,
//                         },
//                         {
//                             from: 500,
//                             to: 1000,
//                         },
//                         {
//                             from: 1000,
//                             to: 2000,
//                         },
//                         {
//                             from: 2000,
//                             to: 3000,
//                         },
//                         {
//                             from: 3000,
//                             to: 5000,
//                         },
//                         {
//                             from: 5000,
//                             to: 7000,
//                         },
//                         {
//                             from: 7000,
//                         },
//                     ],
//                     key: "sellingPrice",
//                     position: "left",
//                     // order: 50
//                 });
//             } catch (error) { }
//             return data;
//         });
//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
//         function (data) {
//             window.wizzyConfig.gridFilters.enabled = false;
//             data.filters.configs.keepOpenedInMobileAfterApply = true;
//             if (window.innerWidth > 1024) {
//                 data.common.lazyDOMConfig.searchInputIdentifiers = [
//                     {
//                         dom: ".wz-search-bar.wz-for-desktop .wz-search-input",
//                         type: "text"
//                     }
//                 ]
//             }
//             else {
//                 data.common.lazyDOMConfig.searchInputIdentifiers = [
//                     {
//                         dom: "#search_mini_form .input-text",
//                         type: "text"
//                     }
//                 ]
//             }

//             window.wizzyConfig.common.view.templates.literals.sortBy = "Sort";
//             window.wizzyConfig.search.configs.pagination.appendInExistingList = "true";

//             window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
//                 desktop: 6e3,
//                 mobile: 10e3,
//             };
//             data.filters.configs.layout = "v1";
//             try {
//                 window.wizzyConfig.search.view.templates.facets.rangeListItem =
//                     "#wizzy-facet-range-list-item";
//                 window.wizzyConfig.search.configs.facets.configs =
//                     window.wizzyConfig.search.configs.facets.configs.filter(
//                         (facet) => facet.key !== "sellingPrice"
//                     );
//                 window.wizzyConfig.search.configs.facets.configs.push({
//                     label: "Price",
//                     buckets: [
//                         {
//                             from: 0,
//                             to: 300,
//                         },
//                         {
//                             from: 300,
//                             to: 500,
//                         },
//                         {
//                             from: 500,
//                             to: 1000,
//                         },
//                         {
//                             from: 1000,
//                             to: 2000,
//                         },
//                         {
//                             from: 2000,
//                             to: 3000,
//                         },
//                         {
//                             from: 3000,
//                             to: 5000,
//                         },
//                         {
//                             from: 5000,
//                             to: 7000,
//                         },
//                         {
//                             from: 7000,
//                         },
//                     ],
//                     key: "sellingPrice",
//                     position: "left",
//                     // order: 50
//                 });
//             } catch (error) { }
//             return data;
//         });


//     window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED, function (payload) {

//         if (payload.response.payload.facets) {
//             payload.response.payload.facets.forEach((facet) => {
//                 if (facet.key === "product_sub_category_custom") {
//                     const facetData = facet.data;
//                     if (facetData) {
//                         facetData.forEach(size => {
//                             size.isVisualSwatch = true;
//                             size.isSwatch = true;
//                             size.isURLSwatch = true;

//                             const imageKey = size.key;
//                             const convertedKey = imageKey
//                                 .toLowerCase()
//                                 .replace(/[^a-z0-9]/g, '');


//                             size.swatchValue = `https://headsupfortails.com/cdn/shop/files/Fil_${convertedKey}.png`;
//                         });
//                         facet.data = facetData;
//                     }
//                 }
//             });
//         }

//         return payload
//     })

//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
//         function (data) {
//             try {
//                 const query = data.payload?.products?.filters?.q?.toLowerCase()?.trim();
//                 // Get mapped collections for the query
//                 var result = [];
//                 var mappedCollections = [];
//                 if (typeof window.getQueryCollections === "function") {
//                     mappedCollections = window.getQueryCollections(query);
//                 }

//                 if (mappedCollections !== 'undefined' && mappedCollections.length > 0) {
//                     result = mappedCollections.map(item => ({
//                         value: item.title,
//                         valueHighlighted: item.title,
//                         filters: {
//                             categories: [item.handle]
//                         },
//                         payload: [
//                             { key: "parentId", value: "" },
//                             { key: "categoryId", value: item.handle },
//                             { key: "categoryImage", value: "" },
//                             {
//                                 key: "relatedCategories",
//                                 value: [
//                                     {
//                                         id: item.handle,
//                                         name: item.title,
//                                         parentId: "",
//                                         image: "",
//                                         url: `https://headsupfortails.com${item.url}`,
//                                         pathIds: [item.handle],
//                                         description: "",
//                                         suggestInOthers: true
//                                     }
//                                 ]
//                             },
//                             { key: "isGlued", value: false }
//                         ]
//                     }));

//                     if (data && data.payload && data.payload.categories) {
//                         data.payload.categories = [...result, ...data.payload.categories].slice(0, 6);;
//                     }
//                 }


//                 data?.payload?.categories?.forEach(category => {
//                     category.payload.forEach(payloadItem => {
//                         if (payloadItem.key === "relatedCategories" && Array.isArray(payloadItem.value)) {
//                             payloadItem.value.forEach(relCat => {
//                                 if (typeof relCat.id === "string" && relCat.id.includes("_wzAc")) {
//                                     delete relCat.url;
//                                 }
//                             });
//                         }
//                     });
//                 });

//             } catch (error) {
//                 console.log(error);
//             }
//             return data;
//         }
//     );

//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
//         function (data) {

//             if (data && !data.isForDefault) {
//                 data?.suggestions?.forEach(suggestion => {
//                     if (suggestion && suggestion.group === "categories") {
//                         if (suggestion.isHead) {
//                             suggestion.label = "Categories";
//                         }
//                     }
//                 });
//             }

//             return data;
//         }
//     )

//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
//         function (data) {
//             data.ignoreRelaxed = 'true';
//             return data;
//         })

//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.BEFORE_FILTER_EXECUTED,
//         function (data) {
//             data.payload.enforcePriceRangeFromQuery = 'true';
//             return data;
//         })

//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
//         function (data) {
//             data.enforcePriceRangeFromQuery = 'true';
//             document.body.classList.remove('wz-home-page');
//             document.body.classList.add('wz-shift-footer');

//             if (window.innerWidth <= 1024) {
//                 const closeBtn = document.querySelector(".wizzy-search-form .wizzy-search-back");
//                 if (closeBtn) {
//                     closeBtn.click();
//                 }
//             }

//             if (data.sort && data.sort.length >= 1 && data.sort[0].field === "relevance") {
//                 data.sort = [{
//                     field: "relevance",
//                     order: "asc"
//                 },
//                 {
//                     field: "sellingPrice",
//                     order: "asc",
//                     isForParent: false,
//                     isForVariation: true
//                 }];
//             }

//             // data.filters.includeOutOfStock = true;
//             return data;
//         });
//     const colorMap = new Map([
//         [
//             "Multicolor",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_multicolor.png?v=14369579796825777196",
//                 !0,
//             ],
//         ],
//         [
//             "Beige",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_beige.png?215713",
//                 !0
//             ]
//         ],
//         [
//             "Black",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_black.png?v=11097879911617316353",
//                 !0
//             ]
//         ],
//         [
//             "Blue",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_blue.png?v=9009033393428036014",
//                 !0
//             ]
//         ],
//         [
//             "Brown",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_brown.png?v=2308316004106137001",
//                 !0
//             ]
//         ],
//         [
//             "Dark Grey",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_darkgrey.png?215713",
//                 !0
//             ]
//         ],
//         [
//             "Green",
//             [
//                 "	https://headsupfortails.com/cdn/shop/files/Fil_green.png?v=1585653486350373395",
//                 !0
//             ]
//         ],
//         [
//             "Grey",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_grey.png?v=4105372538275196224",
//                 !0
//             ]
//         ],
//         [
//             "Navy",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_navy.png?v=6077831343693164629",
//                 !0
//             ]
//         ],
//         [
//             "Orange",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_orange.png?v=14385499723329342574",
//                 !0
//             ]
//         ],
//         [
//             "Pink",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_pink.png?v=18056457893069670200",
//                 !0
//             ]
//         ],
//         [
//             "Purple",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_purple.png?v=3060208004062744979",
//                 !0
//             ]
//         ],
//         [
//             "Red",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_red.png?v=2162505063186107085",
//                 !0
//             ]
//         ],
//         [
//             "Red & Yellow",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_redyellow.png?215713",
//                 !0
//             ]
//         ],
//         [
//             "Silver",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_silver.png?v=18097193189108290842",
//                 !0
//             ]
//         ],
//         [
//             "Turquoise",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_turquoise.png?v=6281790939639245060",
//                 !0
//             ]
//         ],
//         [
//             "Yellow",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_yellow.png?v=2950090085554716001",
//                 !0
//             ]
//         ],
//         [
//             "White",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_white.png?v=12119079014440995654",
//                 !0
//             ]
//         ],
//         [
//             "Yelow",
//             [
//                 "https://headsupfortails.com/cdn/shop/files/Fil_yelow.png?215713",
//                 !0
//             ]
//         ],

//     ]);
//     function findHaxCode(key) {
//         return colorMap.has(key) ? colorMap.get(key) : [key, !1];
//     }
//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
//         function (payload) {

//             if (payload.response.payload) {
//                 if (payload.response.payload.hasToRedirect) {
//                     window.location.href = payload.response.payload.redirectTo;
//                 }
//             }

//             if (payload.api === "search" || payload.api === "filter") {
//                 var facets = payload.response.payload.facets;
//                 facets.forEach((facet) => {
//                     facet.key === "product_colour_custom" &&
//                         facet.data.forEach((item) => {
//                             let color = findHaxCode(item.key);
//                             (item.isSwatch = !0),
//                                 (item.isURLSwatch = true),
//                                 (item.isVisualSwatch = !0),
//                                 (item.swatchValue = color[0]),
//                                 (item.data = {
//                                     value: item.key,
//                                     swatch: {
//                                         type: "visual",
//                                         value: color[0],
//                                     },
//                                 });
//                         });
//                 });
//             }
//             return payload;
//         });


//     function getNearestStore(accessToken, lineItems) {
//         const url = "https://api.headsupfortails.com/order/plp/get-nearest-store";
//         var pinCode = window.sessionStorage.getItem("DTL_pin");
//         const payload = {
//             request_no: 1000000023,
//             pin_code: pinCode,
//             line_items: lineItems
//         };

//         return fetch(url, {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//                 "huft-api-access-token": accessToken
//             },
//             body: JSON.stringify(payload)
//         }).then(function (response) {
//             if (!response.ok) {
//                 throw new Error("API failed with status " + response.status);
//             }
//             return response.json();
//         }).then(function (data) {
//             return data; // resolved value
//         })
//             .catch(function (error) {
//                 console.error("getNearestStore error:", error);
//                 throw error;
//             });
//     }

//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
//         function (data) {
//             handleScroll();
//             var payload = [];
//             const variantToEdtMap = {};

//             if ((data.data.api === "search" && data?.data?.response?.payload?.result.length > 0) || (data.data.api === "filter")) {
//                 const products = data?.data?.response?.payload?.result;
//                 products.forEach(product => {
//                     payload.push({
//                         "variant_id": product.id,
//                         "product_id": product.groupId,
//                         "quantity": 1
//                     })
//                 });

//                 const response = getNearestStore("sqe24re913hf3r423y0933wexweufnw753903h649fdjv34vqaonc950wr9vn3cmm9056odjwtue3u6i3i64qa2", payload).then(function (data) {
//                     const expressDelivaryProductList = data?.data;
//                     expressDelivaryProductList.forEach(item => {
//                         variantToEdtMap[item.p_variant_id] = item.edt;
//                     });

//                     Object.keys(variantToEdtMap).forEach(function (variantId) {
//                         const edtText = variantToEdtMap[variantId];

//                         const li = document.querySelector('li.wizzy-result-product[data-id="' + variantId + '"] .CLS_NewATCWidget');
//                         if (!li) return;
//                         if (li.querySelector(".CL_deliveryInfo")) return;

//                         const deliveryDiv = document.createElement("div");
//                         deliveryDiv.className = "CL_deliveryInfo";
//                         deliveryDiv.innerHTML = `
//                         <span>
//                         <img src="https://cdn.shopify.com/s/files/1/0086/0795/7054/files/timer_icon_781c2c32-1afb-4282-a068-b74d4060a63f.svg?v=1767865832">Get It ${edtText}
//                         </span>
//                         `;
//                         li.appendChild(deliveryDiv);
//                     });
//                 });



//                 if (window.innerWidth < 768) {
//                     const sortBy = document.querySelector(".wizzy-search-sort-wrapper");
//                     const sortByWrapper = document.querySelector(".wizzy-sort-wrapper-in-filter");

//                     if (sortBy && sortByWrapper && !sortByWrapper.contains(sortBy)) {
//                         const clonedSortBy = sortBy.cloneNode(true);
//                         sortByWrapper.appendChild(clonedSortBy);
//                     }
//                 }

//             }
//             try {
//                 sortProductSwatches();
//             } catch (e) {
//                 console.log(e);

//             }

//             if (data.data.api === "autocomplete") {
//                 const searchedQuery = document.querySelector(".autocomplete-top-products-view-more .wizzy-autocomplete-top-products-view-more");
//                 if (searchedQuery) {
//                     searchedQuery.textContent = 'View all results for ' + data?.data?.response?.payload?.products?.filters?.q;
//                 }
//             }

//             return data;
//         })

//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
//         function (products) {
//             products.forEach((product) => {
//                 if (product.price) {
//                     product.price = String(product.price).replace(/\.00$/, "");
//                 }
//                 if (product.sellingPrice) {
//                     product.sellingPrice = String(product.sellingPrice).replace(/\.00$/, "");
//                 }
//             });

//             try {
//                 products.forEach((product) => {
//                     const discountMap = new Map();
//                     const priceMap = new Map();
//                     const sellingPriceMap = new Map();
//                     let attributes = product.attributes;
//                     product.isPersonalisedProduct = false;
//                     product.showQuickDrawer = false;

//                     const comparePriceMap = {};
//                     let productVariantPrices = [];
//                     let productVariantCompareAtPrices = [];
//                     attributes.forEach(atr => {
//                         if (atr.id === "product_variant_prices") {
//                             productVariantPrices = getValueFromNestedAttr(atr);
//                             if (atr.values.length > 1) {
//                                 product.showQuickDrawer = true;
//                             }
//                         }
//                         if (atr.id === "product_variant_compare_at_prices") {
//                             productVariantCompareAtPrices = getValueFromNestedAttr(atr);
//                         }
//                     });

//                     if (productVariantCompareAtPrices && productVariantCompareAtPrices.length > 0
//                     ) {
//                         productVariantCompareAtPrices?.forEach(item => {
//                             comparePriceMap[item.variationId] = item.value[0];
//                         });
//                         const discounts = productVariantPrices?.map(item => {
//                             const price = item.value[0];
//                             const comparePrice = comparePriceMap[item.variationId];
//                             if (!comparePrice || comparePrice <= price) {
//                                 return {
//                                     variationId: item.variationId,
//                                     discountPercent: 0
//                                 };
//                             }
//                             const discountPercent = Math.round(((comparePrice - price) / comparePrice) * 100);
//                             return {
//                                 variationId: item.variationId,
//                                 discountPercent
//                             };
//                         });

//                         product.maxVariantDiscountPercentage = Math.max(...discounts.map(d => d.discountPercent));
//                     }

//                     if (attributes) {
//                         attributes.forEach((attr) => {
//                             if (attr.id === "product_product_type") {
//                                 product.productType = getValueFromNestedAttr(attr)[0].value[0];
//                             }
//                             if (attr.id === "product_handle") {
//                                 product.handle = getValueFromNestedAttr(attr)[0].value[0];
//                             }
//                             else if (attr.id === "product_sale_label_my_fields") {
//                                 product.sale_label = getValueFromNestedAttr(attr)[0].value[0];
//                             }
//                             else if (attr.id === "product_size_chart_custom") {
//                                 product.productSizeChart = attr.values[0].value[0];
//                             }
//                             else if (attr.id === "product_product_catalog_usps_custom") {
//                                 product.category_labels = [];
//                                 product.hasCategoryLabel = true;
//                                 getValueFromNestedAttr(attr)?.forEach((val) => {
//                                     const [beforeHash, afterHash] = val.value[0].split("#");
//                                     product.category_labels.push({
//                                         name: beforeHash,
//                                         collectionHandle: afterHash
//                                     })
//                                 })
//                             }
//                             else if (attr.id === "product_badge_judgeme") {
//                                 let htmlString = getValueFromNestedAttr(attr)[0].value[0];
//                                 const parser = new DOMParser();
//                                 const doc = parser.parseFromString(htmlString, 'text/html');

//                                 const div = doc.querySelector('.jdgm-prev-badge');
//                                 let reviewCount = div.getAttribute('data-average-rating');
//                                 // let num = parseFloat(reviewCount);

//                                 // Convert to string and keep only one decimal place if needed
//                                 if (reviewCount.includes('.') && reviewCount.endsWith('00')) {
//                                     reviewCount = reviewCount.slice(0, -1);
//                                 }
//                                 if (reviewCount === '0.0') {
//                                     reviewCount = 0;
//                                 }
//                                 product.reviewCount = reviewCount;
//                             }
//                             else if (attr.id === "product_variant_discounts_percentage") {
//                                 getValueFromNestedAttr(attr)?.forEach(item => {
//                                     const discount = item.value?.[0] ?? 0;
//                                     discountMap.set(item.variationId, discount);
//                                 });
//                             }
//                             else if (attr.id === "product_variant_prices") {
//                                 getValueFromNestedAttr(attr)?.forEach(item => {
//                                     const sellingPrice = item.value?.[0] ?? 0;
//                                     sellingPriceMap.set(item.variationId, sellingPrice);
//                                 });
//                             }
//                             else if (attr.id === "product_variant_compare_at_prices") {
//                                 getValueFromNestedAttr(attr)?.forEach(item => {
//                                     const price = item.value?.[0] ?? 0;
//                                     priceMap.set(item.variationId, price);
//                                 });
//                             }
//                             else if (attr.id === "product_product_badges_custom") {
//                                 const [text, textColor, backgroundColor] = getValueFromNestedAttr(attr)[0]?.value[0]?.split(',').map(v => v.trim());
//                                 const result = {
//                                     text,
//                                     textColor,
//                                     backgroundColor
//                                 };
//                                 product.badge = result;
//                             }
//                             else if (attr.id === "product_Weight") {
//                                 product.productWeight = getValueFromNestedAttr(attr)[0].value[0];
//                             }
//                             else if (attr.id === "product_Pack Size") {
//                                 product.productPackSize = getValueFromNestedAttr(attr)[0].value[0];
//                             }
//                             else if (attr.id === "product_Size") {
//                                 product.productSize = getValueFromNestedAttr(attr)[0].value[0];
//                             } else if (attr.id === "product_tags") {
//                                 let tags = attr.values[0].value[0];
//                                 product.isPersonalisedProduct = tags.split(',').map(tag => tag.trim()).includes('Personalised');
//                             }
//                         })
//                     }

//                     let swatches = product.swatches;
//                     if (swatches) {
//                         if (swatches.length > 1) {
//                             product.multiple_swatch = true;
//                         }
//                         else {
//                             product.single_swatch = true;
//                         }
//                         swatches.forEach((swatch) => {
//                             swatch.values.forEach((sw) => {
//                                 const price = priceMap.get(sw.variationId);
//                                 const sellingPrice = sellingPriceMap.get(sw.variationId);

//                                 if (price && sellingPrice) {

//                                     let discount = ((price - sellingPrice) / price) * 100;

//                                     discount = Math.round(discount);
//                                     sw.swatch_discount = discount
//                                 } else {

//                                     sw.swatch_discount = 0;
//                                 }
//                             })
//                         })
//                     }
//                     else {
//                         product.swatch_count = 0;
//                     }
//                     if (swatches) {
//                         let swatch_count = 1;
//                         swatches.forEach((swatch) => {
//                             if (swatch.key === "product_Size") {
//                                 product.sizes = swatch;
//                                 if (swatch.values.length > 0) {
//                                     swatch_count *= swatch.values.length;
//                                 }
//                             }
//                             else if (swatch.key === "product_Weight") {
//                                 product.product_weights = swatch;
//                                 if (swatch.values.length > 0) {
//                                     swatch_count *= swatch.values.length;
//                                 }
//                             }
//                             else if (swatch.key === "product_Pack Size") {
//                                 product.product_pack_sizes = swatch;
//                                 if (swatch.values.length > 0) {
//                                     swatch_count *= swatch.values.length;
//                                 }
//                             }
//                         })

//                         product.swatch_count = swatch_count - 1;
//                     }

//                 })
//             }
//             catch (e) {
//                 console.log(e);
//             }

//             return products;
//         });
//     function addTopFilterClicks() {
//         // Swiper click
//         document.addEventListener("click", function (e) {
//             // find the closest swiper slide that was clicked
//             const slide = e.target.closest(".swiper-slide");
//             if (!slide) return; // not clicked on a slide

//             // get its key
//             const key = slide.dataset.key;
//             if (!key || key === "product_veg_non_veg_custom") return;
//             const filterEntry = document.querySelector(".wizzy-filters-desktop-entry");
//             if (filterEntry) filterEntry.click();

//             setTimeout(() => {
//                 const filterWrapper = document.querySelector(".wizzy-facet-list-block");
//                 const scrollContainer = document.querySelector(".wizzy-search-filters-left-wrapper");

//                 if (!filterWrapper || !scrollContainer) return;


//                 const targetFacet = filterWrapper.querySelector(`.wizzy-filters-facet-block[data-key="${key}"]`);
//                 if (targetFacet) {

//                     const offsetTop = targetFacet.offsetTop - 60;
//                     scrollContainer.scrollTo({
//                         top: offsetTop,
//                         behavior: "smooth"
//                     });
//                 }
//             }, 100);
//         });


//     }
//     function handleButtonClickForVegNVeg() {
//         let input_ele = document.querySelector('.product_veg_non_veg_custom .plp_veg .mobile-facets__checkbox');
//         // if(input_ele)
//         // {
//         //     if(input_ele.hasAttribute("checked"))
//         //     {
//         //         window.checkVegNveg = false;
//         //     }
//         //     else
//         //     {
//         //         window.checkVegNveg = true;
//         //     }
//         // }
//         const currentURL = window.location.href
//             , updatedURL = updateURL(currentURL, "product_veg_non_veg_custom[]", "Veg");
//         window.executeWizzyFiltersFromURL(updatedURL);


//     }
//     function updateURL(url, key, value) {
//         const urlObj = new URL(url);
//         urlObj.searchParams.has(key) ? urlObj.searchParams.delete(key) : urlObj.searchParams.append(key, value);
//         var newURL = urlObj.toString().replace(/%5B%5D/g, "[]");
//         return newURL
//     }

//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
//         function (data) {

//             if ((data.data.api === "search" || data.data.api === "filter") && data.data.response.payload.total !== 0) {

//                 if (window.innerWidth < 1025) {
//                     const summaryHead = document.querySelector(".wizzy-search-summary-container");
//                     const container = document.querySelector('.wizzy-search-summary-container');
//                     if (!container) return;
//                     container.innerHTML = '';

//                     const p = document.createElement('p');
//                     p.className = 'wizzy-summary-head';
//                     const text1 = document.createTextNode(`${data?.data?.response?.payload?.total} Results found for `);
//                     const strong = document.createElement('strong');
//                     strong.textContent = `"${data?.data?.response?.payload?.filters?.q}"`;
//                     p.appendChild(text1);
//                     p.appendChild(strong);

//                     container.appendChild(p);
//                 }

//                 const ul = document.querySelector('.wizzy-search-results-list');
//                 [...ul.children].forEach((li, index) => {
//                     li.dataset.gaindex = index;
//                 });

//                 ////////////////////////////////////////// /////////////////////////////////////////////////
//                 const swiperWrapper = document.querySelector('.wz-filters-list-top-wrapper .swiper-wrapper');
//                 const facetBlock = document.querySelector('.wizzy-filters-facet-block[data-key="product_featured_filters_custom"]');

//                 if (swiperWrapper && facetBlock) {
//                     const clonedFacetBlock = facetBlock.cloneNode(true);
//                     const facetHead = clonedFacetBlock.querySelector('.wizzy-facet-head');
//                     if (facetHead) facetHead.remove();

//                     clonedFacetBlock.className
//                         .split(/\s+/)          // split by whitespace
//                         .filter(cls => cls)    // remove empty strings
//                         .forEach(cls => swiperWrapper.classList.add(cls));

//                     const dataKey = clonedFacetBlock.getAttribute('data-key');
//                     if (dataKey) {
//                         swiperWrapper.setAttribute('data-key', dataKey);
//                     }

//                     const facetItems = clonedFacetBlock.querySelectorAll('.wizzy-facet-list-item');
//                     swiperWrapper.innerHTML = '';
//                     facetItems.forEach(item => {
//                         const slide = document.createElement('div');
//                         slide.classList.add('swiper-slide', 'facet-slide'); // keep swiper-slide class
//                         slide.appendChild(item.cloneNode(true));
//                         swiperWrapper.appendChild(slide);
//                     });
//                 }
//                 //////////////////////////////////////////////////////////////////////////////////////////////

//                 const productTypeFacet = document.querySelector('.wizzy-facet-list-block .wizzy-filters-facet-block[data-key="product_sub_category_custom"]');
//                 const plpLeftPanel = document.querySelector('.wizzy-search-results-wrapper .plp_sidebar_inner');

//                 if (productTypeFacet && plpLeftPanel) {
//                     const clonedFacet = productTypeFacet.cloneNode(true);
//                     plpLeftPanel.innerHTML = ''; // Clear existing content
//                     plpLeftPanel.appendChild(clonedFacet); // Append the cloned facet
//                 }

//                 const plpLeftPanelMobile = document.querySelector('.wizzy-search-results-wrapper .plp_left_side.mobile .plp_sidebar_inner');
//                 if (productTypeFacet && plpLeftPanelMobile && document.documentElement.clientWidth < 768) {
//                     const clonedFacet = productTypeFacet.cloneNode(true);
//                     plpLeftPanelMobile.innerHTML = ''; // Clear existing content
//                     plpLeftPanelMobile.appendChild(clonedFacet); // Append the cloned facet
//                 }

//                 //////////////////////////////////////////////////////////////////////////////////////////////

//                 const filterButton = document.querySelector('.wizzy-search-filters-drawer-button.filter-btn');
//                 const sortButton = document.querySelector('.wizzy-search-filters-drawer-button.sort');
//                 const swiperWrapperNew = document.querySelector('.wz-filters-list-top-wrapper .swiper-wrapper');
//                 const alreadyAddedFilterButton = swiperWrapperNew?.querySelector('.cloned-filter-btn');
//                 const alreadyAddedSortButton = swiperWrapperNew?.querySelector('.cloned-sort-btn');

//                 if (filterButton && sortButton && swiperWrapperNew) {
//                     const currentAppliedSort = document.querySelector(".wizzy-common-select-option.selected");
//                     const sortLabel = sortButton.querySelector(".wizzy-common-select-label");
//                     const sortSelectedItems = sortButton.querySelector(".wizzy-common-select-selectedItem");
//                     if (currentAppliedSort && currentAppliedSort.textContent.trim() != "Featured") {
//                         sortLabel.textContent = currentAppliedSort.textContent;
//                         sortButton.classList.add("sort-applied");
//                     }

//                     if (!alreadyAddedSortButton) {
//                         const clonedSortButton = sortButton.cloneNode(true);
//                         clonedSortButton.classList.add('cloned-sort-btn');
//                         swiperWrapperNew.insertBefore(clonedSortButton, swiperWrapperNew.firstChild);    // Insert sort button next
//                     }
//                     if (!alreadyAddedFilterButton) {
//                         const clonedFilterButton = filterButton.cloneNode(true);
//                         clonedFilterButton.classList.add('cloned-filter-btn');
//                         swiperWrapperNew.insertBefore(clonedFilterButton, swiperWrapperNew.firstChild);  // Insert filter button first
//                     }


//                     // filterButton.parentNode.removeChild(filterButton);  // Remove the original filter button
//                     // sortButton.parentNode.removeChild(sortButton);      // Remove the original sort button
//                 }

//                 //////////////////////////////////////////////////////////////////////////////////////////////

//                 document.body.classList.remove('wz-shift-footer');
//                 const facetItems = document.querySelectorAll('.wizzy-selected-facet-list li');
//                 const facetCounts = {};
//                 facetItems.forEach(li => {
//                     const key = li.getAttribute('data-facetkey');
//                     if (key) {
//                         facetCounts[key] = (facetCounts[key] || 0) + 1;
//                     }
//                 });
//                 // Step 3: Select all swiper slides
//                 const swiperSlides = document.querySelectorAll('.swiper-slide');

//                 // Step 4: Match and update slides
//                 swiperSlides.forEach(slide => {
//                     const slideKey = slide.getAttribute('data-key');
//                     if (slideKey && facetCounts[slideKey]) {
//                         slide.querySelector('.detailstop_txt').classList.add('filter_active');
//                         slide.setAttribute('data-count', facetCounts[slideKey]);
//                         let count_ele = slide.querySelector('.flt_count_0');
//                         if (count_ele) {
//                             count_ele.className = 'flt_count_' + facetCounts[slideKey];
//                             count_ele.textContent = '(' + facetCounts[slideKey] + ')';
//                         }
//                     }
//                 });
//                 let sort_options = document.querySelectorAll('.wizzy-common-select-option');
//                 if (sort_options) {
//                     sort_options.forEach((option) => {
//                         option.addEventListener('click', function () {
//                             document.documentElement.classList.remove('wizzy-filters-overlay');
//                             document.body.classList.remove('wizzy-filters-overlay');
//                         })
//                     })
//                 }
//                 let apply_button = document.querySelector('.wizzy-apply-all-button-block');
//                 if (apply_button) {
//                     apply_button.addEventListener('click', function () {
//                         let close_btn = document.querySelector('.wizzy-filters-close-btn');
//                         if (close_btn) {
//                             close_btn.click();
//                         }
//                     })
//                 }
//                 const swiperContainer = document.querySelector('.wizzy-search-wrapper .swiper-container');

//                 if (swiperContainer && !swiperContainer.classList.contains('swiper-initialized')) {
//                     new Swiper(swiperContainer, {
//                         slidesPerView: 'auto',
//                         spaceBetween: 10,
//                         // navigation: {
//                         // nextEl: '.swiper-button-next',
//                         // prevEl: '.swiper-button-prev',
//                         // },
//                         freeMode: true,
//                         loop: false,
//                     });
//                 }

//                 addTopFilterClicks();

//                 let veg_nveg = document.querySelector('.product_veg_non_veg_custom .plp_veg .mobile-facets__label');
//                 if (veg_nveg) {
//                     veg_nveg.addEventListener('click', handleButtonClickForVegNVeg);
//                 }
//                 let input_ele = document.querySelector('.product_veg_non_veg_custom .plp_veg .mobile-facets__checkbox');
//                 if (input_ele) {
//                     const url = new URL(window.location.href);
//                     if (url.searchParams.has("product_veg_non_veg_custom[]")) {
//                         input_ele.setAttribute("checked", true);
//                     }
//                 }

//                 //////////////////////////////////////////////////////////////////////////////////////

//                 const allFacets = document.querySelectorAll(".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block");
//                 if (allFacets && allFacets.length > 0) {
//                     var totalActiveFilter = 0;
//                     allFacets.forEach(facetItem => {
//                         var activeFilterCount = 0;
//                         const filterItems = facetItem.querySelectorAll(".wizzy-facet-list .active");
//                         if (filterItems) {
//                             filterItems.forEach(item => {
//                                 activeFilterCount += 1;
//                                 totalActiveFilter += 1;
//                             });
//                         }

//                         if (activeFilterCount > 0) {
//                             const span = document.createElement("span");
//                             span.classList.add("active-count");
//                             span.textContent = `(${activeFilterCount})`;

//                             const el = document.querySelector(".swiper-container .wizzy-filters-desktop-entry");
//                             if (el && !el.classList.contains("active")) {
//                                 el.classList.add("active");
//                             }

//                             const title = facetItem.querySelector(".facet-head-title");
//                             if (title) {
//                                 const existingTitle = title.querySelector(".active-count");
//                                 if (!existingTitle) {
//                                     title.appendChild(span);
//                                 }
//                             }
//                         }
//                     })

//                     if (totalActiveFilter > 0) {
//                         const span = document.createElement("span");
//                         span.classList.add("active-count");
//                         span.textContent = ` (${totalActiveFilter})`;
//                         const titleFilter = document.querySelector(".wizzy-filters-header .header-title");
//                         if (titleFilter) {
//                             const existingSpan = titleFilter.querySelector(".active-count");
//                             if (!existingSpan) {
//                                 // titleFilter.appendChild(span);
//                                 titleFilter.appendChild(span.cloneNode(true));
//                             }
//                         }

//                         const titleFilterMain = document.querySelector(".swiper-container .wizzy-filters-title");
//                         if (titleFilterMain) {
//                             const existingMainSpan = titleFilterMain.querySelector(".active-count");
//                             if (!existingMainSpan) {
//                                 // titleFilterMain.appendChild(span);
//                                 titleFilterMain.appendChild(span.cloneNode(true));
//                             }
//                         }
//                     }

//                 }

//                 //////////////////////////////////////////////////////////////////////////////////////

//                 const facetBlocks = document.querySelectorAll('.wizzy-search-filters-left-wrapper .wizzy-filters-facet-block');

//                 if (facetBlocks) {
//                     facetBlocks.forEach(block => {
//                         const facetList = block.querySelector('.wizzy-facet-list');
//                         const listItems = facetList.querySelectorAll('li');
//                         const itemsToShow = 6; // Adjust the number of items to show initially (approx 2 rows)
//                         const button = block.querySelector('.toggle-button');

//                         for (let i = 0; i < listItems.length; i++) {
//                             if (i >= itemsToShow) {
//                                 listItems[i].style.display = 'none'; // Hide
//                             }
//                         }

//                         if (listItems.length <= itemsToShow) {
//                             button.style.display = 'none'; // Hide the button if not enough items
//                         } else {
//                             button.style.display = 'block'; // Show the button if there are enough items
//                         }
//                     });
//                 }
//             }

//             //////////////////////////////////////////////////////////////////////////////////////

//             if (data?.data?.api === "autocomplete") {
//                 const products = data?.data?.response?.payload?.products;
//                 const query = products?.filters?.q?.toLowerCase()?.trim();

//                 if (!query) return;

//                 const suggestions = window.getQuerySuggestions(query);

//                 if (suggestions && suggestions.length > 0) {

//                     const container = document.querySelector(".wizzy-autocomplete-custom-suggestion");

//                     if (container) {
//                         container.innerHTML = "";
//                         suggestions.forEach(item => {

//                             const suggestionHTML = `
//                             <div class="suggestion-item">
//                                 <a href="${item.url}" target="_blank" class="suggestion-link">
//                                     <img src="${item.image}" alt="${item.title}" class="suggestion-image" />
//                                     <span class="suggestion-title">${item.title}</span>
//                                     <span class="suggestion-title-tag">Suggested</span>
//                                 </a>
//                             </div>
//                         `;

//                             container.innerHTML += suggestionHTML;
//                         });
//                     }
//                 }
//             }

//             // if (data?.data?.api === "autocomplete") {
//             //     const products = data?.data?.response?.payload?.products;
//             //     const query = products?.filters?.q?.toLowerCase()?.trim();

//             //     // Get mapped collections for the query
//             //     const mappedCollections = window.getQueryCollections(query);

//             //     if (mappedCollections.length > 0) {
//             //         const topCategoriesList = document.querySelector('.autocomplete-suggestions-list.regular-autocomplete');

//             //         if (topCategoriesList) {
//             //             // Find the 'Categories' head item
//             //             const categoriesHead = topCategoriesList.querySelector('.autocomplete-item-head');

//             //             if (categoriesHead) {
//             //                 // Generate <li> elements for each mapped collection
//             //                 const collectionLis = mappedCollections.map((col, index) => {
//             //                     const li = document.createElement('li');
//             //                     li.className = 'autocomplete-item-abc';

//             //                     li.innerHTML = `
//             //             <a data-selectable="true" data-searchterm="${col.title}" href="${col.url}" class="autocomplete-link-abc" data-index="${index}">
//             //                 <div class="wz-searchIcon-svg">
//             //                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//             //                         <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="#979797" stroke-linecap="round" stroke-linejoin="round"></path>
//             //                         <path d="M20.9984 20.9984L16.6484 16.6484" stroke="#979797" stroke-linecap="round" stroke-linejoin="round"></path>
//             //                     </svg>
//             //                 </div>
//             //                 <span class="wizzy-autocomplete-label">${col.title}</span>
//             //                 <span class="autocomplete-text-wrapper"></span>
//             //             </a>
//             //         `;
//             //                     return li;
//             //                 });

//             //                 // Insert each new <li> just after the Categories head
//             //                 collectionLis.reverse().forEach(li => {
//             //                     categoriesHead.insertAdjacentElement('afterend', li);
//             //                 });
//             //             }
//             //         }
//             //     }
//             // }


//             //code for making sure that when only one filter option is availbe hide left pannel and make sure that product grid is getting full width
//             const leftPannelFilterOptions = document.querySelectorAll(".wizzy-search-wrapper .plp_left_side.desktop .plp_sidebar_inner .wizzy-filters-facet-block.facet-block-product_sub_category_custom .wizzy-facet-body ul.wizzy-facet-list li.wizzy-facet-list-item");
//             if (leftPannelFilterOptions && leftPannelFilterOptions.length <= 1) {
//                 const leftPannel = document.querySelector(".wizzy-search-wrapper .plp_left_side.desktop");
//                 const wizzySearchResultsContainer = document.querySelector(".wizzy-search-results-container");
//                 const wizzySearchResultsWrapper = document.querySelector(".wizzy-search-wrapper .wizzy-search-results-wrapper");
//                 if (leftPannel) {
//                     leftPannel.style.width = "0%";
//                     leftPannel.style.border = "none";

//                     wizzySearchResultsWrapper.style.gap = "0";
//                     wizzySearchResultsContainer.style.setProperty('width', '100%', 'important');
//                 }
//             }

//             return data;
//         });
//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
//         function (data) {

//             ////////////////////////////////////////// /////////////////////////////////////////////////
//             const swiperWrapper = document.querySelector('.wz-filters-list-top-wrapper .swiper-wrapper');
//             const facetBlock = document.querySelector('.wizzy-filters-facet-block[data-key="product_featured_filters_custom"]');

//             if (swiperWrapper && facetBlock) {
//                 const clonedFacetBlock = facetBlock.cloneNode(true);
//                 const facetHead = clonedFacetBlock.querySelector('.wizzy-facet-head');
//                 if (facetHead) facetHead.remove();

//                 clonedFacetBlock.className
//                     .split(/\s+/)          // split by whitespace
//                     .filter(cls => cls)    // remove empty strings
//                     .forEach(cls => swiperWrapper.classList.add(cls));

//                 const dataKey = clonedFacetBlock.getAttribute('data-key');
//                 if (dataKey) {
//                     swiperWrapper.setAttribute('data-key', dataKey);
//                 }

//                 const facetItems = clonedFacetBlock.querySelectorAll('.wizzy-facet-list-item');
//                 swiperWrapper.innerHTML = '';
//                 facetItems.forEach(item => {
//                     const slide = document.createElement('div');
//                     slide.classList.add('swiper-slide', 'facet-slide'); // keep swiper-slide class
//                     slide.appendChild(item.cloneNode(true));
//                     swiperWrapper.appendChild(slide);
//                 });
//             }
//             //////////////////////////////////////////////////////////////////////////////////////////////

//             const productTypeFacet = document.querySelector('.wizzy-facet-list-block .wizzy-filters-facet-block[data-key="product_sub_category_custom"]');
//             const plpLeftPanel = document.querySelector('.wizzy-search-results-wrapper .plp_sidebar_inner');

//             if (productTypeFacet && plpLeftPanel) {
//                 const clonedFacet = productTypeFacet.cloneNode(true);
//                 plpLeftPanel.innerHTML = ''; // Clear existing content
//                 plpLeftPanel.appendChild(clonedFacet); // Append the cloned facet
//             }

//             const plpLeftPanelMobile = document.querySelector('.wizzy-search-results-wrapper .plp_left_side.mobile .plp_sidebar_inner');
//             if (productTypeFacet && plpLeftPanelMobile && document.documentElement.clientWidth < 768) {
//                 const clonedFacet = productTypeFacet.cloneNode(true);
//                 plpLeftPanelMobile.innerHTML = ''; // Clear existing content
//                 plpLeftPanelMobile.appendChild(clonedFacet); // Append the cloned facet
//             }

//             //////////////////////////////////////////////////////////////////////////////////////////////

//             const filterButton = document.querySelector('.wizzy-search-filters-drawer-button.filter-btn');
//             const sortButton = document.querySelector('.wizzy-search-filters-drawer-button.sort');
//             const swiperWrapperNew = document.querySelector('.wz-filters-list-top-wrapper .swiper-wrapper');

//             if (filterButton && sortButton && swiperWrapperNew) {
//                 const clonedFilterButton = filterButton.cloneNode(true);
//                 const clonedSortButton = sortButton.cloneNode(true);

//                 swiperWrapperNew.insertBefore(clonedSortButton, swiperWrapperNew.firstChild);    // Insert sort button next
//                 swiperWrapperNew.insertBefore(clonedFilterButton, swiperWrapperNew.firstChild);  // Insert filter button first

//                 // filterButton.parentNode.removeChild(filterButton);  // Remove the original filter button
//                 // sortButton.parentNode.removeChild(sortButton);      // Remove the original sort button
//             }

//             ////////////////////////////////////// //////////////////////////////////////

//             document.body.classList.remove('wz-shift-footer');
//             const facetItems = document.querySelectorAll('.wizzy-selected-facet-list li');
//             const facetCounts = {};
//             facetItems.forEach(li => {
//                 const key = li.getAttribute('data-facetkey');
//                 if (key) {
//                     facetCounts[key] = (facetCounts[key] || 0) + 1;
//                 }
//             });
//             // Step 3: Select all swiper slides
//             const swiperSlides = document.querySelectorAll('.swiper-slide');

//             // Step 4: Match and update slides
//             swiperSlides.forEach(slide => {
//                 const slideKey = slide.getAttribute('data-key');
//                 if (slideKey && facetCounts[slideKey]) {
//                     slide.querySelector('.detailstop_txt').classList.add('filter_active');
//                     slide.setAttribute('data-count', facetCounts[slideKey]);
//                     let count_ele = slide.querySelector('.flt_count_0');
//                     if (count_ele) {
//                         count_ele.className = 'flt_count_' + facetCounts[slideKey];
//                         count_ele.textContent = '(' + facetCounts[slideKey] + ')';
//                     }
//                 }
//             });
//             let sort_options = document.querySelectorAll('.wizzy-common-select-option');
//             if (sort_options) {
//                 sort_options.forEach((option) => {
//                     option.addEventListener('click', function () {
//                         document.documentElement.classList.remove('wizzy-filters-overlay');
//                         document.body.classList.remove('wizzy-filters-overlay');
//                     })
//                 })
//             }
//             let apply_button = document.querySelector('.wizzy-apply-all-button-block');
//             if (apply_button) {
//                 apply_button.addEventListener('click', function () {
//                     let close_btn = document.querySelector('.wizzy-filters-close-btn');
//                     if (close_btn) {
//                         close_btn.click();
//                     }
//                 })
//             }
//             const swiperContainer = document.querySelector('.wizzy-search-wrapper .swiper-container');

//             if (swiperContainer && !swiperContainer.classList.contains('swiper-initialized')) {
//                 new Swiper(swiperContainer, {
//                     slidesPerView: 'auto',
//                     spaceBetween: 10,
//                     navigation: {
//                         nextEl: '.swiper-button-next',
//                         prevEl: '.swiper-button-prev',
//                     },
//                     freeMode: true,
//                     loop: false,
//                 });
//             }

//             addTopFilterClicks();

//             let veg_nveg = document.querySelector('.product_veg_non_veg_custom .plp_veg .mobile-facets__label');
//             if (veg_nveg) {
//                 veg_nveg.addEventListener('click', handleButtonClickForVegNVeg);
//             }
//             let input_ele = document.querySelector('.product_veg_non_veg_custom .plp_veg .mobile-facets__checkbox');
//             if (input_ele) {
//                 const url = new URL(window.location.href);
//                 if (url.searchParams.has("product_veg_non_veg_custom[]")) {
//                     input_ele.setAttribute("checked", true);
//                 }
//             }


//             //////////////////////////////////////////////////////////////////////////////////////

//             const allFacets = document.querySelectorAll(".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block");
//             if (allFacets && allFacets.length > 0) {
//                 var totalActiveFilter = 0;
//                 allFacets.forEach(facetItem => {
//                     var activeFilterCount = 0;
//                     const filterItems = facetItem.querySelectorAll(".wizzy-facet-list .active");
//                     if (filterItems) {
//                         filterItems.forEach(item => {
//                             activeFilterCount += 1;
//                             totalActiveFilter += 1;
//                         });
//                     }

//                     if (activeFilterCount > 0) {
//                         const span = document.createElement("span");
//                         span.classList.add("active-count");
//                         span.textContent = `(${activeFilterCount})`;

//                         const el = document.querySelector(".swiper-container .wizzy-filters-desktop-entry");
//                         if (el && !el.classList.contains("active")) {
//                             el.classList.add("active");
//                         }

//                         const title = facetItem.querySelector(".facet-head-title");
//                         if (title) {
//                             const existingTitle = title.querySelector(".active-count");
//                             if (!existingTitle) {
//                                 title.appendChild(span);
//                             }
//                         }
//                     }
//                 })

//                 if (totalActiveFilter > 0) {
//                     const span = document.createElement("span");
//                     span.classList.add("active-count");
//                     span.textContent = ` (${totalActiveFilter})`;
//                     const titleFilter = document.querySelector(".wizzy-filters-header .header-title");
//                     if (titleFilter) {
//                         const existingSpan = titleFilter.querySelector(".active-count");
//                         if (!existingSpan) {
//                             // titleFilter.appendChild(span);
//                             titleFilter.appendChild(span.cloneNode(true));
//                         }
//                     }

//                     const titleFilterMain = document.querySelector(".swiper-container .wizzy-filters-title");
//                     if (titleFilterMain) {
//                         const existingMainSpan = titleFilterMain.querySelector(".active-count");
//                         if (!existingMainSpan) {
//                             // titleFilterMain.appendChild(span);
//                             titleFilterMain.appendChild(span.cloneNode(true));
//                         }
//                     }
//                 }

//             }

//             //////////////////////////////////////////////////////////////////////////////////////

//             const facetBlocks = document.querySelectorAll('.wizzy-search-filters-left-wrapper .wizzy-filters-facet-block');

//             if (facetBlocks) {
//                 facetBlocks.forEach(block => {
//                     const facetList = block.querySelector('.wizzy-facet-list');
//                     const listItems = facetList.querySelectorAll('li');
//                     const itemsToShow = 6; // Adjust the number of items to show initially (approx 2 rows)
//                     const button = block.querySelector('.toggle-button');

//                     for (let i = 0; i < listItems.length; i++) {
//                         if (i >= itemsToShow) {
//                             listItems[i].style.display = 'none'; // Hide
//                         }
//                     }

//                     if (listItems.length <= itemsToShow) {
//                         button.style.display = 'none'; // Hide the button if not enough items
//                     } else {
//                         button.style.display = 'block'; // Show the button if there are enough items
//                     }
//                 });
//             }

//             //////////////////////////////////////////////////////////////////////////////////////

//             return data;
//         });
// }


// ////////////////////////////////////////////////////////////////////////////////////////////////////




// const clearIconMobile = document.querySelector(".wz-mobile-searchbox .wz-search-bar svg.wz-autocomplete-cross-icon");
// const searchInputsMobile = document.querySelectorAll(".wz-mobile-searchbox .wz-search-input");

// if (clearIconMobile && searchInputsMobile.length > 0) {
//     clearIconMobile.addEventListener("click", function () {
//         searchInputsMobile.forEach(input => {
//             input.value = '';
//         });
//     });
// }



const SIZE_ORDER = ["XXS", "XS", "S", "M", "L/XL", "L", "XL", "XXL", "3XL", "4XL", "5XL", "6XL"];
function sortProductSwatches() {
    function getSortValue(btn) {
        const rawText =
            (btn.dataset.variantText || btn.textContent || "")
                .toUpperCase()
                .replace(/\s+/g, " ")
                .trim();

        /* ---------- SIZE SORT ---------- */
        if (SIZE_ORDER.includes(rawText)) {
            return SIZE_ORDER.indexOf(rawText);
        }

        // 3XL, 4XL, 5XL...
        const xlMatch = rawText.match(/^(\d+)XL$/);
        if (xlMatch) {
            return SIZE_ORDER.length + parseInt(xlMatch[1], 10);
        }

        /* ---------- WEIGHT SORT (G / KG) ---------- */
        const weightMatch = rawText.match(/(\d+(\.\d+)?)\s*(KG|G)\b/);
        if (weightMatch) {
            let value = parseFloat(weightMatch[1]);
            if (weightMatch[3] === "KG") value *= 1000; // normalize to grams
            return value;
        }

        /* ---------- LENGTH SORT (MM / CM / M) ---------- */
        const lengthMatch = rawText.match(/(\d+(\.\d+)?)\s*(MM|CM|M)\b/);
        if (lengthMatch) {
            let value = parseFloat(lengthMatch[1]);
            const unit = lengthMatch[3];

            // normalize everything to millimeters
            if (unit === "CM") value *= 10;
            if (unit === "M") value *= 1000;

            return value;
        }

        /* ---------- PACK SORT ---------- */
        const packMatch = rawText.match(/\bPACK OF\s*(\d+)/);
        if (packMatch) {
            return parseInt(packMatch[1], 10);
        }

        /* ---------- FALLBACK ---------- */
        const numMatch = rawText.match(/\d+(\.\d+)?/);
        if (numMatch) {
            return parseFloat(numMatch[0]);
        }

        return Number.MAX_SAFE_INTEGER;
    }

    document.querySelectorAll(".CLS_optionsItems").forEach(group => {
        const buttons = Array.from(
            group.querySelectorAll("button.singleOptionBtn")
        );

        if (buttons.length < 2) return;

        buttons
            .sort((a, b) => getSortValue(a) - getSortValue(b))
            .forEach(btn => group.appendChild(btn));
    });
}


function getValueFromNestedAttr(attr) {
    if (attr.nestedValues) {
        return attr.nestedValues;
    } else {
        return attr.values;
    }
}

if (window.location.pathname === '/') {
    document.body.classList.add('wz-home-page');
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 100) {
            $("body").addClass("wz-scroll");
        }
        else {
            $("body").removeClass("wz-scroll");
        }
    });
}
else {
    document.body.classList.remove('wz-home-page');
}
const storageKey = "pageHistory";
const currentPage = window.location.href;

let pageHistory = JSON.parse(localStorage.getItem(storageKey)) || [];

if (!pageHistory.length || pageHistory[pageHistory.length - 1] !== currentPage) {
    pageHistory.push(currentPage);
    localStorage.setItem(storageKey, JSON.stringify(pageHistory));
}
$(".gobackhistory").on("click", function (e) {
    e.preventDefault();

    pageHistory.pop();
    const previousPage = pageHistory.pop();

    if (previousPage) {
        localStorage.setItem(storageKey, JSON.stringify(pageHistory));
        window.location.href = previousPage;
    } else {
        window.location.href = "/";
    }
});

function isSearchPage() {
    return window.location.pathname.includes("/search");
}

function getQueryFromURL() {
    const params = new URLSearchParams(window.location.search);
    return params.get("q") || "";
}

if (window.innerWidth <= 1024) {
    (function () {
        const bodyEndWrapper = document.querySelector(".wizzy-body-end-wrapper");

        if (!bodyEndWrapper) return;

        let timeout = null;

        function handleToggle() {
            if (document.body.classList.contains("wizzyMobileTapped")) {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    bodyEndWrapper.style.display = "block";
                }, 500);
            } else {
                clearTimeout(timeout);
                bodyEndWrapper.style.display = "none";
            }
        }
        handleToggle();
        const observer = new MutationObserver(handleToggle);
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ["class"]
        });
    })();


    const searchIcon = document.querySelectorAll('.MSH_searchOuter button, .MSH_searchIconOuter .MSH_newIcons');
    const searchInput2 = document.querySelector("#search_mini_form .input-text");
    const backButton = document.querySelector("#search_mini_form .wizzy-search-back");

    if (searchIcon) {
        searchIcon.forEach(icon => {
        icon.addEventListener("click", () => {
            if (!searchInput2) return;
                searchInput2.value = "";
                // Must not defer: mobile browsers only associate the keyboard with focus that
                // runs in the same turn as the user's tap; setTimeout breaks that chain.
                searchInput2.click();
                if (searchFormWrapper && document.body.classList.contains("wizzyMobileTapped")) {
                    searchFormWrapper.classList.add("wizzy-search-drawer-open");
                    searchInput2.focus({ preventScroll: true });
                }
            });
        });
    }

    if (searchInput2 && backButton) {
        searchInput2.addEventListener("keydown", function (e) {
            if (e.key === "Enter" && isSearchPage()) {
                const inputValue = this.value.trim();
                const urlQuery = getQueryFromURL().trim();
                if (inputValue && inputValue === urlQuery) {
                    backButton.click();
                }
            }
        });
    }

    if (searchInput2) {
        searchInput2.addEventListener("input", function () {
            if (this.value === "") {
                searchInput2.click();
            }
        });

        searchInput2.addEventListener("keydown", function (e) {
            if (e.key === "Backspace" && this.value === "") {
                searchInput2.click();
            }
        });
    }
} else {
    // document.addEventListener("click", function (e) {
    //     const clearIcon = e.target.closest(".wz-autocomplete-cross-icon");
    //     const searchInput = document.querySelector(".wz-search-bar.wz-for-desktop .wz-search-input");

    //     if (clearIcon && searchInput) {
    //         searchInput.value = "";
    //         searchInput.dispatchEvent(new Event("input", { bubbles: true }));
    //         searchInput.focus();
    //     }
    // });
    document.addEventListener(
  "mousedown",
  function (e) {
    const clearIcon = e.target.closest(".wz-autocomplete-cross-icon");
    if (!clearIcon) return;

    const searchInput = document.querySelector(
      ".wz-search-bar.wz-for-desktop .wz-search-input"
    );

    if (searchInput) {
      e.preventDefault(); // prevents blur issue
      e.stopPropagation(); // avoid interference

      searchInput.value = "";
      searchInput.dispatchEvent(new Event("input", { bubbles: true }));
      searchInput.focus();
    }
  },
  true // 👈 capture phase (VERY IMPORTANT)
);
}

(function setupWizzyMobileSearchDrawerSlideIn() {
    function isMobileSearchBreakpoint() {
        if(window.innerWidth <= 1024) {
            return true;
        }
        return false;
    }

    function bind() {
        const wrapper = document.querySelector(".wizzy-search-form-wrapper");
        if (!wrapper || wrapper.dataset.wizzyDrawerSlideBound === "1") return;
        if (!wrapper.querySelector(".wizzy-search-form")) return;
        wrapper.dataset.wizzyDrawerSlideBound = "1";

        function queueSlideOpen() {
            if (!isMobileSearchBreakpoint() || !document.body.classList.contains("wizzyMobileTapped")) {
                return;
            }
            // wrapper.classList.remove("wizzy-search-drawer-open");
            // void wrapper.offsetWidth;
            // requestAnimationFrame(function () {
            //     requestAnimationFrame(function () {
            //         if (document.body.classList.contains("wizzyMobileTapped") && isMobileSearchBreakpoint()) {
            //             wrapper.classList.add("wizzy-search-drawer-open");
            //         }
            //     });
            // });
            wrapper.classList.add("wizzy-search-drawer-open");
        }

        function syncDrawerFromBody() {
            if (!isMobileSearchBreakpoint()) {
                wrapper.classList.remove("wizzy-search-drawer-open");
                return;
            }
            if (document.body.classList.contains("wizzyMobileTapped")) {
                if (!wrapper.classList.contains("wizzy-search-drawer-open")) {
                    queueSlideOpen();
                }
            } else {
                wrapper.classList.remove("wizzy-search-drawer-open");
            }
        }

        const observer = new MutationObserver(syncDrawerFromBody);
        observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
        window.addEventListener("resize", syncDrawerFromBody);

        syncDrawerFromBody();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bind);
    } else {
        bind();
    }
})();


function closeSearchDrawer() {
    const closeBtn = document.querySelector(".wizzy-search-form .wizzy-search-back");
    if (closeBtn) {
        closeBtn.click();
    }
}

if(window.innerWidth <= 1024) {
    window.addEventListener("load", closeSearchDrawer);
    window.addEventListener("pageshow", function (event) {
        if (event.persisted) {
            closeSearchDrawer();
        }
    });
}


window.onWizzyScriptLoaded = function () {

    const searchBar = document.querySelectorAll(".wz-search-bar .wz-search-input");
    searchBar.forEach((sbar) => {
        sbar.addEventListener("click", () => {
            setTimeout(() => {
                let autoCompleteArrows = document.querySelectorAll(".autocomplete-text-wrapper");
                if (autoCompleteArrows) {
                    autoCompleteArrows.forEach((arrow) => {
                        if (arrow) {
                            arrow.addEventListener("click", () => {
                                sbar.value = arrow.parentElement.getAttribute("data-searchterm");
                                sbar.focus();
                            });
                        }
                    });
                }
            }, 300)
        });
    });

    // const targetNode = document.querySelector(".wizzy-body-end-wrapper");
    // function updateBodyClass() {
    //     const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
    //     autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
    // }
    // const config = {
    //     childList: !0,
    //     subtree: !0,
    //     attributes: !0,
    //     attributeFilter: ["style"]
    // }
    //     , callback = function (mutationsList, observer2) {
    //         for (const mutation of mutationsList) {
    //             updateBodyClass();
    //             break
    //         }
    //     }
    //     , observer = new MutationObserver(callback);
    // targetNode && (observer.observe(targetNode, config),
    //     updateBodyClass());



    // let lastScrollTop = 0;
    // function handleScroll() {
    //     const currentScrollTop = $(window).scrollTop();
    //     if (currentScrollTop >= 100) {
    //         $(".wz-filters-list-top-wrapper").addClass("fixedplp_top_rsidebar");
    //         $("body").addClass("wz-scroll");
    //     } else {
    //         $(".wz-filters-list-top-wrapper").removeClass("fixedplp_top_rsidebar");
    //         $("body").removeClass("wz-scroll");
    //     }

    //     if (currentScrollTop < lastScrollTop && currentScrollTop > 200) {
    //         $(".wz-filters-list-top-wrapper").addClass("filter_menu_top");
    //     } else {
    //         $(".wz-filters-list-top-wrapper").removeClass("filter_menu_top");
    //     }
    //     lastScrollTop = currentScrollTop;
    // }


    // $(window).on("scroll", handleScroll);
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
        function (data) {

            window.wizzyConfig.gridFilters.enabled = false;
            window.wizzyConfig.common.view.templates.literals.sortBy = "Sort";
            // window.wizzyConfig.credentials = {
            //     "apiKey": "Z1UvQTZ6VEcrdTBVZ05rYmNGUVBWOWNrREt3NTNERmN2VmU1ZnVLYWx6SGptdTlDRjJodStESjhTeXNYVTVhczdKVld1WDV3TU5aWVBneHdzcnZnUU8vUG55SFZkUXFtT25xS00zc3NhMzA9",
            //     "storeId": "6526f806b3c511f092560a0c8095feae"
            // };

            // dev store credentials
            // data.credentials = {
            //     "apiKey": "c1FNWE5HN2lTKzQ5enlUanVTZzVSOG14aGExeDFLbzNGZHR0UGRPT3Jxb0t0NDJDWFdVa2JVN251QklyamlUUDlKT3Zpd1Q3WlFQOW1CQ0Q5ajMxUHB6bWp6ZVRGcGxSNGhZNHI5WXI1cVk9",
            //     "storeId": "33381c500af811f19e330a0c8095feae"
            // };

            data.filters.configs.keepOpenedInMobileAfterApply = true;
            if (window.innerWidth > 1024) {
                data.common.lazyDOMConfig.searchInputIdentifiers = [
                    {
                        dom: ".wz-search-bar.wz-for-desktop .wz-search-input",
                        type: "text"
                    }
                ]
            }
            else {
                data.common.lazyDOMConfig.searchInputIdentifiers = [
                    {
                        dom: "#search_mini_form .input-text",
                        type: "text"
                    }
                ]
            }
            window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
                desktop: 6e3,
                mobile: 10e3,
            };
            data.filters.configs.layout = "v1";
            window.wizzyConfig.search.configs.pagination.appendInExistingList = "true";

            try {
                window.wizzyConfig.search.view.templates.facets.rangeListItem =
                    "#wizzy-facet-range-list-item";
                window.wizzyConfig.search.configs.facets.configs =
                    window.wizzyConfig.search.configs.facets.configs.filter(
                        (facet) => facet.key !== "sellingPrice"
                    );
                window.wizzyConfig.search.configs.facets.configs.push({
                    label: "Price",
                    buckets: [
                        {
                            from: 0,
                            to: 300,
                        },
                        {
                            from: 300,
                            to: 500,
                        },
                        {
                            from: 500,
                            to: 1000,
                        },
                        {
                            from: 1000,
                            to: 2000,
                        },
                        {
                            from: 2000,
                            to: 3000,
                        },
                        {
                            from: 3000,
                            to: 5000,
                        },
                        {
                            from: 5000,
                            to: 7000,
                        },
                        {
                            from: 7000,
                        },
                    ],
                    key: "sellingPrice",
                    position: "left",
                    // order: 50
                });
            } catch (error) { }
            return data;
        });
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
        function (data) {
            window.wizzyConfig.gridFilters.enabled = false;
            data.filters.configs.keepOpenedInMobileAfterApply = true;
            if (window.innerWidth > 1024) {
                data.common.lazyDOMConfig.searchInputIdentifiers = [
                    {
                        dom: ".wz-search-bar.wz-for-desktop .wz-search-input",
                        type: "text"
                    }
                ]
            }
            else {
                data.common.lazyDOMConfig.searchInputIdentifiers = [
                    {
                        dom: "#search_mini_form .input-text",
                        type: "text"
                    }
                ]
            }

            window.wizzyConfig.common.view.templates.literals.sortBy = "Sort";
            window.wizzyConfig.search.configs.pagination.appendInExistingList = "true";

            window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
                desktop: 6e3,
                mobile: 10e3,
            };
            data.filters.configs.layout = "v1";
            try {
                window.wizzyConfig.search.view.templates.facets.rangeListItem =
                    "#wizzy-facet-range-list-item";
                window.wizzyConfig.search.configs.facets.configs =
                    window.wizzyConfig.search.configs.facets.configs.filter(
                        (facet) => facet.key !== "sellingPrice"
                    );
                window.wizzyConfig.search.configs.facets.configs.push({
                    label: "Price",
                    buckets: [
                        {
                            from: 0,
                            to: 300,
                        },
                        {
                            from: 300,
                            to: 500,
                        },
                        {
                            from: 500,
                            to: 1000,
                        },
                        {
                            from: 1000,
                            to: 2000,
                        },
                        {
                            from: 2000,
                            to: 3000,
                        },
                        {
                            from: 3000,
                            to: 5000,
                        },
                        {
                            from: 5000,
                            to: 7000,
                        },
                        {
                            from: 7000,
                        },
                    ],
                    key: "sellingPrice",
                    position: "left",
                    // order: 50
                });
            } catch (error) { }
            return data;
        });


    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED, function (payload) {

        if (payload.response.payload.facets) {
            payload.response.payload.facets.forEach((facet) => {
                if (facet.key === "product_sub_category_custom") {
                    const facetData = facet.data;
                    if (facetData) {
                        facetData.forEach(size => {
                            size.isVisualSwatch = true;
                            size.isSwatch = true;
                            size.isURLSwatch = true;

                            const imageKey = size.key;
                            const convertedKey = imageKey
                                .toLowerCase()
                                .replace(/[^a-z0-9]/g, '');


                            size.swatchValue = `https://headsupfortails.com/cdn/shop/files/Fil_${convertedKey}.png`;
                        });
                        facet.data = facetData;
                    }
                }
            });
        }

        return payload
    })

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
        function (data) {
            try {
                const query = data.payload?.products?.filters?.q?.toLowerCase()?.trim();
                // Get mapped collections for the query
                var result = [];
                var mappedCollections = [];
                if (typeof window.getQueryCollections === "function") {
                    mappedCollections = window.getQueryCollections(query);
                }

                if (mappedCollections !== 'undefined' && mappedCollections.length > 0) {
                    result = mappedCollections.map(item => ({
                        value: item.title,
                        valueHighlighted: item.title,
                        filters: {
                            categories: [item.handle]
                        },
                        payload: [
                            { key: "parentId", value: "" },
                            { key: "categoryId", value: item.handle },
                            { key: "categoryImage", value: "" },
                            {
                                key: "relatedCategories",
                                value: [
                                    {
                                        id: item.handle,
                                        name: item.title,
                                        parentId: "",
                                        image: "",
                                        url: `https://headsupfortails.com${item.url}`,
                                        pathIds: [item.handle],
                                        description: "",
                                        suggestInOthers: true
                                    }
                                ]
                            },
                            { key: "isGlued", value: false }
                        ]
                    }));

                    if (data && data.payload && data.payload.categories) {
                        data.payload.categories = [...result, ...data.payload.categories].slice(0, 6);;
                    }
                }


                data?.payload?.categories?.forEach(category => {
                    category.payload.forEach(payloadItem => {
                        if (payloadItem.key === "relatedCategories" && Array.isArray(payloadItem.value)) {
                            payloadItem.value.forEach(relCat => {
                                if (typeof relCat.id === "string" && relCat.id.includes("_wzAc")) {
                                    delete relCat.url;
                                }
                            });
                        }
                    });
                });

            } catch (error) {
                console.log(error);
            }
            return data;
        }
    );

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
        function (data) {

            if (data && !data.isForDefault) {
                data?.suggestions?.forEach(suggestion => {
                    if (suggestion && suggestion.group === "categories") {
                        if (suggestion.isHead) {
                            suggestion.label = "Categories";
                        }
                    }
                });
            }

            return data;
        }
    )

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
        function (data) {
            data.ignoreRelaxed = 'true';
            return data;
        })

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_FILTER_EXECUTED,
        function (data) {
            data.payload.enforcePriceRangeFromQuery = 'true';
            return data;
        })

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
        function (data) {
            data.enforcePriceRangeFromQuery = 'true';
            document.body.classList.remove('wz-home-page');
            document.body.classList.add('wz-shift-footer');

            if (window.innerWidth <= 1024) {
                const closeBtn = document.querySelector(".wizzy-search-form .wizzy-search-back");
                if (closeBtn) {
                    closeBtn.click();
                }
            }

            if (data.sort && data.sort.length >= 1 && data.sort[0].field === "relevance") {
                data.sort = [{
                    field: "relevance",
                    order: "asc"
                },
                {
                    field: "sellingPrice",
                    order: "asc",
                    isForParent: false,
                    isForVariation: true
                }];
            }

            // data.filters.includeOutOfStock = true;
            return data;
        });
    const colorMap = new Map([
        [
            "Multicolor",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_multicolor.png?v=14369579796825777196",
                !0,
            ],
        ],
        [
            "Beige",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_beige.png?215713",
                !0
            ]
        ],
        [
            "Black",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_black.png?v=11097879911617316353",
                !0
            ]
        ],
        [
            "Blue",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_blue.png?v=9009033393428036014",
                !0
            ]
        ],
        [
            "Brown",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_brown.png?v=2308316004106137001",
                !0
            ]
        ],
        [
            "Dark Grey",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_darkgrey.png?215713",
                !0
            ]
        ],
        [
            "Green",
            [
                "	https://headsupfortails.com/cdn/shop/files/Fil_green.png?v=1585653486350373395",
                !0
            ]
        ],
        [
            "Grey",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_grey.png?v=4105372538275196224",
                !0
            ]
        ],
        [
            "Navy",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_navy.png?v=6077831343693164629",
                !0
            ]
        ],
        [
            "Orange",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_orange.png?v=14385499723329342574",
                !0
            ]
        ],
        [
            "Pink",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_pink.png?v=18056457893069670200",
                !0
            ]
        ],
        [
            "Purple",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_purple.png?v=3060208004062744979",
                !0
            ]
        ],
        [
            "Red",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_red.png?v=2162505063186107085",
                !0
            ]
        ],
        [
            "Red & Yellow",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_redyellow.png?215713",
                !0
            ]
        ],
        [
            "Silver",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_silver.png?v=18097193189108290842",
                !0
            ]
        ],
        [
            "Turquoise",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_turquoise.png?v=6281790939639245060",
                !0
            ]
        ],
        [
            "Yellow",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_yellow.png?v=2950090085554716001",
                !0
            ]
        ],
        [
            "White",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_white.png?v=12119079014440995654",
                !0
            ]
        ],
        [
            "Yelow",
            [
                "https://headsupfortails.com/cdn/shop/files/Fil_yelow.png?215713",
                !0
            ]
        ],

    ]);
    function findHaxCode(key) {
        return colorMap.has(key) ? colorMap.get(key) : [key, !1];
    }
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
        function (payload) {

            if (payload.response.payload) {
                if (payload.response.payload.hasToRedirect) {
                    window.location.href = payload.response.payload.redirectTo;
                }
            }

            if (payload.api === "search" || payload.api === "filter") {
                var facets = payload.response.payload.facets;
                facets.forEach((facet) => {
                    facet.key === "product_colour_custom" &&
                        facet.data.forEach((item) => {
                            let color = findHaxCode(item.key);
                            (item.isSwatch = !0),
                                (item.isURLSwatch = true),
                                (item.isVisualSwatch = !0),
                                (item.swatchValue = color[0]),
                                (item.data = {
                                    value: item.key,
                                    swatch: {
                                        type: "visual",
                                        value: color[0],
                                    },
                                });
                        });
                });
            }
            return payload;
        });


    const HUFT_DTL_API_TOKEN = "sqe24re913hf3r423y0933wexweufnw753903h649fdjv34vqaonc950wr9vn3cmm9056odjwtue3u6i3i64qa2";

    function chunkArray(arr, size) {
        const res = [];
        for (let i = 0; i < arr.length; i += size) {
            res.push(arr.slice(i, i + size));
        }
        return res;
    }

    function getExpressFilterStorageKey() {
        return "filter_EXPR_DTL_search_" + window.location.pathname + window.location.search;
    }

    function showExpressDeliveryPill() {
        document.querySelectorAll(".wizzy-search-wrapper .filter_EXPR_DTL_outer").forEach(function (el) {
            el.classList.remove("EXPR_hide");
        });
    }

    function applyExpressDeliveryFilter() {
        document.querySelectorAll("li.wizzy-result-product:not(.DTLExtress_Active)").forEach(function (el) {
            el.classList.add("dtl_fast_hide");
        });
        document.querySelectorAll(".wizzy-search-wrapper .filter_EXPR_DTL").forEach(function (el) {
            el.classList.add("active");
        });
    }

    function removeExpressDeliveryFilter() {
        document.querySelectorAll("li.wizzy-result-product.dtl_fast_hide").forEach(function (el) {
            el.classList.remove("dtl_fast_hide");
        });
        document.querySelectorAll(".wizzy-search-wrapper .filter_EXPR_DTL").forEach(function (el) {
            el.classList.remove("active");
        });
    }

    function toggleExpressDeliveryFilter() {
        const pageKey = getExpressFilterStorageKey();
        if (sessionStorage.getItem(pageKey) === "active") {
            sessionStorage.removeItem(pageKey);
            removeExpressDeliveryFilter();
        } else {
            sessionStorage.setItem(pageKey, "active");
            applyExpressDeliveryFilter();
        }
    }

    function restoreExpressDeliveryFilter() {
        const pageKey = getExpressFilterStorageKey();
        if (sessionStorage.getItem(pageKey) !== "active") return;
        setTimeout(function () {
            if (document.querySelectorAll(".wizzy-search-results-list .DTLExtress_Active").length > 0) {
                applyExpressDeliveryFilter();
            } else {
                removeExpressDeliveryFilter();
                sessionStorage.removeItem(pageKey);
            }
        }, 1500);
    }

    function clearSearchExpressDeliveryState() {
        document.querySelectorAll("li.wizzy-result-product").forEach(function (card) {
            card.removeAttribute("data-delivery-checked");
            card.classList.remove("DTLExtress_Active");
            const widget = card.querySelector(".CLS_NewATCWidget");
            if (widget) {
                const info = widget.querySelector(".CL_deliveryInfo");
                if (info) info.remove();
            }
        });
        document.querySelectorAll(".wizzy-search-wrapper .filter_EXPR_DTL_outer").forEach(function (el) {
            el.classList.add("EXPR_hide");
        });
    }

    function findSearchProductCard(variantId) {
        const id = String(variantId);
        let card = document.querySelector('li.wizzy-result-product[data-id="' + id + '"]');
        if (card) return card;
        return Array.from(document.querySelectorAll("li.wizzy-result-product")).find(function (el) {
            return String(el.getAttribute("data-id")) === id;
        }) || null;
    }

    function applyExpressDeliveryTags(variantId, edtText) {
        const card = findSearchProductCard(variantId);
        if (!card) return;
        card.classList.add("DTLExtress_Active");
        showExpressDeliveryPill();
        const widget = card.querySelector(".CLS_NewATCWidget");
        if (!widget || widget.querySelector(".CL_deliveryInfo")) return;
        const deliveryDiv = document.createElement("div");
        deliveryDiv.className = "CL_deliveryInfo";
        deliveryDiv.innerHTML =
            '<span><img src="https://cdn.shopify.com/s/files/1/0086/0795/7054/files/timer_icon_781c2c32-1afb-4282-a068-b74d4060a63f.svg?v=1767865832">Get It ' +
            edtText +
            "</span>";
        widget.appendChild(deliveryDiv);
    }

    function getNearestStore(accessToken, lineItems) {
        const url = "https://api.headsupfortails.com/order/plp/get-nearest-store";
        var pinCode = window.sessionStorage.getItem("DTL_pin");
        const payload = {
            request_no: 0,
            pin_code: pinCode,
            line_items: lineItems
        };

        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "huft-api-access-token": accessToken
            },
            body: JSON.stringify(payload)
        }).then(function (response) {
            if (!response.ok) {
                throw new Error("API failed with status " + response.status);
            }
            return response.json();
        }).then(function (data) {
            return data;
        })
            .catch(function (error) {
                console.error("getNearestStore error:", error);
                throw error;
            });
    }

    function wizzyCheckDeliveryDates(processAll) {
        const pincode = sessionStorage.getItem("DTL_pin");
        if (!pincode) return Promise.resolve();

        const selector = processAll
            ? "li.wizzy-result-product"
            : "li.wizzy-result-product:not([data-delivery-checked])";
        const cards = Array.from(document.querySelectorAll(selector));

        if (!cards.length) return Promise.resolve();

        const lineItems = [];
        cards.forEach(function (card) {
            const widget = card.querySelector(".CLS_NewATCWidget");
            if (!widget) return;
            const vidInput = widget.querySelector('input[name="id"]');
            const pidInput = widget.querySelector('input[name="product-id"]');
            const vid = vidInput ? vidInput.value : "";
            const pid = pidInput ? pidInput.value : "";
            if (vid && pid) {
                lineItems.push({
                    variant_id: String(vid),
                    product_id: String(pid),
                    quantity: 1
                });
            }
            card.setAttribute("data-delivery-checked", "true");
        });

        if (!lineItems.length) return Promise.resolve();

        const batches = chunkArray(lineItems, 24);
        const promises = batches.map(function (batch) {
            return getNearestStore(HUFT_DTL_API_TOKEN, batch).then(function (response) {
                if (!response?.data?.length) return;
                response.data.forEach(function (item) {
                    applyExpressDeliveryTags(String(item.p_variant_id), item.edt);
                });
            });
        });

        return Promise.all(promises).then(function () {
            if (sessionStorage.getItem(getExpressFilterStorageKey()) === "active") {
                applyExpressDeliveryFilter();
            }
        });
    }

    function bindExpressDeliveryPillButton(btn) {
        if (!btn || btn.dataset.exprDtlBound === "1") return;
        btn.dataset.exprDtlBound = "1";
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleExpressDeliveryFilter();
        });
    }

    function ensureExpressDeliveryPill(swiperWrapper) {
        if (!swiperWrapper) return null;
        let pillSlide = swiperWrapper.querySelector(".filter_EXPR_DTL_outer");
        if (!pillSlide) {
            pillSlide = document.createElement("div");
            pillSlide.className = "swiper-slide filter_EXPR_DTL_outer EXPR_hide facet-slide";
            pillSlide.innerHTML =
                '<button type="button" class="custom-pill filter_EXPR_DTL">Express Delivery</button>';
            const sortBtn = swiperWrapper.querySelector(".cloned-sort-btn");
            if (sortBtn) {
                sortBtn.insertAdjacentElement("afterend", pillSlide);
            } else {
                const filterBtn = swiperWrapper.querySelector(".cloned-filter-btn");
                if (filterBtn) {
                    filterBtn.insertAdjacentElement("afterend", pillSlide);
                } else {
                    swiperWrapper.appendChild(pillSlide);
                }
            }
        }
        const pillBtn = pillSlide.querySelector(".filter_EXPR_DTL");
        bindExpressDeliveryPillButton(pillBtn);
        if (pillBtn && sessionStorage.getItem(getExpressFilterStorageKey()) === "active") {
            pillBtn.classList.add("active");
        }
        if (document.querySelectorAll(".wizzy-search-results-list .DTLExtress_Active").length > 0) {
            pillSlide.classList.remove("EXPR_hide");
        }
        return pillSlide;
    }

    function bindExpressDeliveryPillClick() {
        bindExpressDeliveryPillButton(
            document.querySelector(".wizzy-search-wrapper .filter_EXPR_DTL")
        );
    }

    function initSearchExpressDelivery(processAll) {
        bindExpressDeliveryPillClick();
        const swiperWrapper = document.querySelector(".wz-filters-list-top-wrapper .swiper-wrapper");
        ensureExpressDeliveryPill(swiperWrapper);
        return wizzyCheckDeliveryDates(processAll).then(function () {
            restoreExpressDeliveryFilter();
        });
    }

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
        function (data) {
            handleScroll();

            if ((data.data.api === "search" && data?.data?.response?.payload?.result.length > 0) || (data.data.api === "filter")) {
                if (window.innerWidth < 768) {
                    const sortBy = document.querySelector(".wizzy-search-sort-wrapper");
                    const sortByWrapper = document.querySelector(".wizzy-sort-wrapper-in-filter");

                    if (sortBy && sortByWrapper && !sortByWrapper.contains(sortBy)) {
                        const clonedSortBy = sortBy.cloneNode(true);
                        sortByWrapper.appendChild(clonedSortBy);
                    }
                }

            }
            try {
                sortProductSwatches();
            } catch (e) {
                console.log(e);

            }

            if (data.data.api === "autocomplete") {
                const searchedQuery = document.querySelector(".autocomplete-top-products-view-more .wizzy-autocomplete-top-products-view-more");
                if (searchedQuery) {
                    searchedQuery.textContent = 'View all results for ' + data?.data?.response?.payload?.products?.filters?.q;
                }
            }

            return data;
        })

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
        function (products) {
            products.forEach((product) => {
                if (product.price) {
                    product.price = String(product.price).replace(/\.00$/, "");
                }
                if (product.sellingPrice) {
                    product.sellingPrice = String(product.sellingPrice).replace(/\.00$/, "");
                }
            });

            try {
                products.forEach((product) => {
                    const discountMap = new Map();
                    const priceMap = new Map();
                    const sellingPriceMap = new Map();
                    let attributes = product.attributes;
                    product.isPersonalisedProduct = false;
                    product.showQuickDrawer = false;

                    const comparePriceMap = {};
                    let productVariantPrices = [];
                    let productVariantCompareAtPrices = [];
                    attributes.forEach(atr => {
                        if (atr.id === "product_variant_prices") {
                            productVariantPrices = getValueFromNestedAttr(atr);
                            if (atr.values.length > 1) {
                                product.showQuickDrawer = true;
                            }
                        }
                        if (atr.id === "product_variant_compare_at_prices") {
                            productVariantCompareAtPrices = getValueFromNestedAttr(atr);
                        }
                    });

                    if (productVariantCompareAtPrices && productVariantCompareAtPrices.length > 0
                    ) {
                        productVariantCompareAtPrices?.forEach(item => {
                            comparePriceMap[item.variationId] = item.value[0];
                        });
                        const discounts = productVariantPrices?.map(item => {
                            const price = item.value[0];
                            const comparePrice = comparePriceMap[item.variationId];
                            if (!comparePrice || comparePrice <= price) {
                                return {
                                    variationId: item.variationId,
                                    discountPercent: 0
                                };
                            }
                            const discountPercent = Math.round(((comparePrice - price) / comparePrice) * 100);
                            return {
                                variationId: item.variationId,
                                discountPercent
                            };
                        });

                        product.maxVariantDiscountPercentage = Math.max(...discounts.map(d => d.discountPercent));
                    }

                    if (attributes) {
                        attributes.forEach((attr) => {
                            if (attr.id === "product_product_type") {
                                product.productType = getValueFromNestedAttr(attr)[0].value[0];
                            }
                            if (attr.id === "product_handle") {
                                product.handle = getValueFromNestedAttr(attr)[0].value[0];
                            }
                            else if (attr.id === "product_sale_label_my_fields") {
                                product.sale_label = getValueFromNestedAttr(attr)[0].value[0];
                            }
                            else if (attr.id === "product_size_chart_custom") {
                                product.productSizeChart = attr.values[0].value[0];
                            }
                            else if (attr.id === "product_product_catalog_usps_custom") {
                                product.category_labels = [];
                                product.hasCategoryLabel = true;
                                getValueFromNestedAttr(attr)?.forEach((val) => {
                                    const [beforeHash, afterHash] = val.value[0].split("#");
                                    product.category_labels.push({
                                        name: beforeHash,
                                        collectionHandle: afterHash
                                    })
                                })
                            }
                            else if (attr.id === "product_badge_judgeme") {
                                let htmlString = getValueFromNestedAttr(attr)[0].value[0];
                                const parser = new DOMParser();
                                const doc = parser.parseFromString(htmlString, 'text/html');

                                const div = doc.querySelector('.jdgm-prev-badge');
                                let reviewCount = div.getAttribute('data-average-rating');
                                // let num = parseFloat(reviewCount);

                                // Convert to string and keep only one decimal place if needed
                                if (reviewCount.includes('.') && reviewCount.endsWith('00')) {
                                    reviewCount = reviewCount.slice(0, -1);
                                }
                                if (reviewCount === '0.0') {
                                    reviewCount = 0;
                                }
                                product.reviewCount = reviewCount;
                            }
                            else if (attr.id === "product_variant_discounts_percentage") {
                                getValueFromNestedAttr(attr)?.forEach(item => {
                                    const discount = item.value?.[0] ?? 0;
                                    discountMap.set(item.variationId, discount);
                                });
                            }
                            else if (attr.id === "product_variant_prices") {
                                getValueFromNestedAttr(attr)?.forEach(item => {
                                    const sellingPrice = item.value?.[0] ?? 0;
                                    sellingPriceMap.set(item.variationId, sellingPrice);
                                });
                            }
                            else if (attr.id === "product_variant_compare_at_prices") {
                                getValueFromNestedAttr(attr)?.forEach(item => {
                                    const price = item.value?.[0] ?? 0;
                                    priceMap.set(item.variationId, price);
                                });
                            }
                            else if (attr.id === "product_product_badges_custom") {
                                const [text, textColor, backgroundColor] = getValueFromNestedAttr(attr)[0]?.value[0]?.split(',').map(v => v.trim());
                                const result = {
                                    text,
                                    textColor,
                                    backgroundColor
                                };
                                product.badge = result;
                            }
                            else if (attr.id === "product_Weight") {
                                product.productWeight = getValueFromNestedAttr(attr)[0].value[0];
                            }
                            else if (attr.id === "product_Pack Size") {
                                product.productPackSize = getValueFromNestedAttr(attr)[0].value[0];
                            }
                            else if (attr.id === "product_Size") {
                                product.productSize = getValueFromNestedAttr(attr)[0].value[0];
                            } else if (attr.id === "product_tags") {
                                let tags = attr.values[0].value[0];
                                product.isPersonalisedProduct = tags.split(',').map(tag => tag.trim()).includes('Personalised');
                            }
                        })
                    }

                    let swatches = product.swatches;
                    if (swatches) {
                        if (swatches.length > 1) {
                            product.multiple_swatch = true;
                        }
                        else {
                            product.single_swatch = true;
                        }
                        swatches.forEach((swatch) => {
                            swatch.values.forEach((sw) => {
                                const price = priceMap.get(sw.variationId);
                                const sellingPrice = sellingPriceMap.get(sw.variationId);

                                if (price && sellingPrice) {

                                    let discount = ((price - sellingPrice) / price) * 100;

                                    discount = Math.round(discount);
                                    sw.swatch_discount = discount
                                } else {

                                    sw.swatch_discount = 0;
                                }
                            })
                        })
                    }
                    else {
                        product.swatch_count = 0;
                    }
                    if (swatches) {
                        let swatch_count = 1;
                        swatches.forEach((swatch) => {
                            if (swatch.key === "product_Size") {
                                product.sizes = swatch;
                                if (swatch.values.length > 0) {
                                    swatch_count *= swatch.values.length;
                                }
                            }
                            else if (swatch.key === "product_Weight") {
                                product.product_weights = swatch;
                                if (swatch.values.length > 0) {
                                    swatch_count *= swatch.values.length;
                                }
                            }
                            else if (swatch.key === "product_Pack Size") {
                                product.product_pack_sizes = swatch;
                                if (swatch.values.length > 0) {
                                    swatch_count *= swatch.values.length;
                                }
                            }
                        })

                        product.swatch_count = swatch_count - 1;
                    }

                })
            }
            catch (e) {
                console.log(e);
            }

            return products;
        });
    function addTopFilterClicks() {
        // Swiper click
        document.addEventListener("click", function (e) {
            if (e.target.closest(".filter_EXPR_DTL")) return;

            // find the closest swiper slide that was clicked
            const slide = e.target.closest(".swiper-slide");
            if (!slide) return; // not clicked on a slide
            if (slide.classList.contains("filter_EXPR_DTL_outer")) return;

            // get its key
            const key = slide.dataset.key;
            if (!key || key === "product_veg_non_veg_custom") return;
            const filterEntry = document.querySelector(".wizzy-filters-desktop-entry");
            if (filterEntry) filterEntry.click();

            setTimeout(() => {
                const filterWrapper = document.querySelector(".wizzy-facet-list-block");
                const scrollContainer = document.querySelector(".wizzy-search-filters-left-wrapper");

                if (!filterWrapper || !scrollContainer) return;


                const targetFacet = filterWrapper.querySelector(`.wizzy-filters-facet-block[data-key="${key}"]`);
                if (targetFacet) {

                    const offsetTop = targetFacet.offsetTop - 60;
                    scrollContainer.scrollTo({
                        top: offsetTop,
                        behavior: "smooth"
                    });
                }
            }, 100);
        });


    }
    function handleButtonClickForVegNVeg() {
        let input_ele = document.querySelector('.product_veg_non_veg_custom .plp_veg .mobile-facets__checkbox');
        // if(input_ele)
        // {
        //     if(input_ele.hasAttribute("checked"))
        //     {
        //         window.checkVegNveg = false;
        //     }
        //     else
        //     {
        //         window.checkVegNveg = true;
        //     }
        // }
        const currentURL = window.location.href
            , updatedURL = updateURL(currentURL, "product_veg_non_veg_custom[]", "Veg");
        window.executeWizzyFiltersFromURL(updatedURL);


    }
    function updateURL(url, key, value) {
        const urlObj = new URL(url);
        urlObj.searchParams.has(key) ? urlObj.searchParams.delete(key) : urlObj.searchParams.append(key, value);
        var newURL = urlObj.toString().replace(/%5B%5D/g, "[]");
        return newURL
    }

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
        function (data) {

            if ((data.data.api === "search" || data.data.api === "filter") && data.data.response.payload.total !== 0) {

                if (window.innerWidth < 1025) {
                    const container = document.querySelector('.wizzy-search-summary-container');
                    if (container) {
                        container.innerHTML = '';

                        const p = document.createElement('p');
                        p.className = 'wizzy-summary-head';
                        const text1 = document.createTextNode(`${data?.data?.response?.payload?.total} Results found for `);
                        const strong = document.createElement('strong');
                        strong.textContent = `"${data?.data?.response?.payload?.filters?.q}"`;
                        p.appendChild(text1);
                        p.appendChild(strong);

                        container.appendChild(p);
                    }
                }

                const ul = document.querySelector('.wizzy-search-results-list');
                [...ul.children].forEach((li, index) => {
                    li.dataset.gaindex = index;
                });

                ////////////////////////////////////////// /////////////////////////////////////////////////
                const swiperWrapper = document.querySelector('.wz-filters-list-top-wrapper .swiper-wrapper');
                const facetBlock = document.querySelector('.wizzy-filters-facet-block[data-key="product_featured_filters_custom"]');

                if (swiperWrapper && facetBlock) {
                    const clonedFacetBlock = facetBlock.cloneNode(true);
                    const facetHead = clonedFacetBlock.querySelector('.wizzy-facet-head');
                    if (facetHead) facetHead.remove();

                    clonedFacetBlock.className
                        .split(/\s+/)          // split by whitespace
                        .filter(cls => cls)    // remove empty strings
                        .forEach(cls => swiperWrapper.classList.add(cls));

                    const dataKey = clonedFacetBlock.getAttribute('data-key');
                    if (dataKey) {
                        swiperWrapper.setAttribute('data-key', dataKey);
                    }

                    const facetItems = clonedFacetBlock.querySelectorAll('.wizzy-facet-list-item');
                    swiperWrapper.innerHTML = '';
                    facetItems.forEach(item => {
                        const slide = document.createElement('div');
                        slide.classList.add('swiper-slide', 'facet-slide'); // keep swiper-slide class
                        slide.appendChild(item.cloneNode(true));
                        swiperWrapper.appendChild(slide);
                    });
                }
                //////////////////////////////////////////////////////////////////////////////////////////////

                const productTypeFacet = document.querySelector('.wizzy-facet-list-block .wizzy-filters-facet-block[data-key="product_sub_category_custom"]');
                const plpLeftPanel = document.querySelector('.wizzy-search-results-wrapper .plp_sidebar_inner');

                if (productTypeFacet && plpLeftPanel) {
                    const clonedFacet = productTypeFacet.cloneNode(true);
                    plpLeftPanel.innerHTML = ''; // Clear existing content
                    plpLeftPanel.appendChild(clonedFacet); // Append the cloned facet
                }

                const plpLeftPanelMobile = document.querySelector('.wizzy-search-results-wrapper .plp_left_side.mobile .plp_sidebar_inner');
                if (productTypeFacet && plpLeftPanelMobile && document.documentElement.clientWidth < 768) {
                    const clonedFacet = productTypeFacet.cloneNode(true);
                    plpLeftPanelMobile.innerHTML = ''; // Clear existing content
                    plpLeftPanelMobile.appendChild(clonedFacet); // Append the cloned facet
                }

                //////////////////////////////////////////////////////////////////////////////////////////////

                const filterButton = document.querySelector('.wizzy-search-filters-drawer-button.filter-btn');
                const sortButton = document.querySelector('.wizzy-search-filters-drawer-button.sort');
                const swiperWrapperNew = document.querySelector('.wz-filters-list-top-wrapper .swiper-wrapper');
                const alreadyAddedFilterButton = swiperWrapperNew?.querySelector('.cloned-filter-btn');
                const alreadyAddedSortButton = swiperWrapperNew?.querySelector('.cloned-sort-btn');

                if (filterButton && sortButton && swiperWrapperNew) {
                    const currentAppliedSort = document.querySelector(".wizzy-common-select-option.selected");
                    const sortLabel = sortButton.querySelector(".wizzy-common-select-label");
                    const sortSelectedItems = sortButton.querySelector(".wizzy-common-select-selectedItem");
                    if (currentAppliedSort && currentAppliedSort.textContent.trim() != "Featured") {
                        sortLabel.textContent = currentAppliedSort.textContent;
                        sortButton.classList.add("sort-applied");
                    }

                    if (!alreadyAddedSortButton) {
                        const clonedSortButton = sortButton.cloneNode(true);
                        clonedSortButton.classList.add('cloned-sort-btn');
                        swiperWrapperNew.insertBefore(clonedSortButton, swiperWrapperNew.firstChild);    // Insert sort button next
                    }
                    if (!alreadyAddedFilterButton) {
                        const clonedFilterButton = filterButton.cloneNode(true);
                        clonedFilterButton.classList.add('cloned-filter-btn');
                        swiperWrapperNew.insertBefore(clonedFilterButton, swiperWrapperNew.firstChild);  // Insert filter button first
                    }

                }

                ensureExpressDeliveryPill(swiperWrapperNew);
                clearSearchExpressDeliveryState();
                initSearchExpressDelivery(true);

                //////////////////////////////////////////////////////////////////////////////////////////////

                document.body.classList.remove('wz-shift-footer');
                const facetItems = document.querySelectorAll('.wizzy-selected-facet-list li');
                const facetCounts = {};
                facetItems.forEach(li => {
                    const key = li.getAttribute('data-facetkey');
                    if (key) {
                        facetCounts[key] = (facetCounts[key] || 0) + 1;
                    }
                });
                // Step 3: Select all swiper slides
                const swiperSlides = document.querySelectorAll('.swiper-slide');

                // Step 4: Match and update slides
                swiperSlides.forEach(slide => {
                    const slideKey = slide.getAttribute('data-key');
                    if (slideKey && facetCounts[slideKey]) {
                        slide.querySelector('.detailstop_txt').classList.add('filter_active');
                        slide.setAttribute('data-count', facetCounts[slideKey]);
                        let count_ele = slide.querySelector('.flt_count_0');
                        if (count_ele) {
                            count_ele.className = 'flt_count_' + facetCounts[slideKey];
                            count_ele.textContent = '(' + facetCounts[slideKey] + ')';
                        }
                    }
                });
                let sort_options = document.querySelectorAll('.wizzy-common-select-option');
                if (sort_options) {
                    sort_options.forEach((option) => {
                        option.addEventListener('click', function () {
                            document.documentElement.classList.remove('wizzy-filters-overlay');
                            document.body.classList.remove('wizzy-filters-overlay');
                        })
                    })
                }
                let apply_button = document.querySelector('.wizzy-apply-all-button-block');
                if (apply_button) {
                    apply_button.addEventListener('click', function () {
                        let close_btn = document.querySelector('.wizzy-filters-close-btn');
                        if (close_btn) {
                            close_btn.click();
                        }
                    })
                }
                const swiperContainer = document.querySelector('.wizzy-search-wrapper .swiper-container');

                if (swiperContainer && !swiperContainer.classList.contains('swiper-initialized')) {
                    new Swiper(swiperContainer, {
                        slidesPerView: 'auto',
                        spaceBetween: 10,
                        // navigation: {
                        // nextEl: '.swiper-button-next',
                        // prevEl: '.swiper-button-prev',
                        // },
                        freeMode: true,
                        loop: false,
                    });
                }

                addTopFilterClicks();

                let veg_nveg = document.querySelector('.product_veg_non_veg_custom .plp_veg .mobile-facets__label');
                if (veg_nveg) {
                    veg_nveg.addEventListener('click', handleButtonClickForVegNVeg);
                }
                let input_ele = document.querySelector('.product_veg_non_veg_custom .plp_veg .mobile-facets__checkbox');
                if (input_ele) {
                    const url = new URL(window.location.href);
                    if (url.searchParams.has("product_veg_non_veg_custom[]")) {
                        input_ele.setAttribute("checked", true);
                    }
                }

                //////////////////////////////////////////////////////////////////////////////////////

                const allFacets = document.querySelectorAll(".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block");
                if (allFacets && allFacets.length > 0) {
                    var totalActiveFilter = 0;
                    allFacets.forEach(facetItem => {
                        var activeFilterCount = 0;
                        const filterItems = facetItem.querySelectorAll(".wizzy-facet-list .active");
                        if (filterItems) {
                            filterItems.forEach(item => {
                                activeFilterCount += 1;
                                totalActiveFilter += 1;
                            });
                        }

                        if (activeFilterCount > 0) {
                            const span = document.createElement("span");
                            span.classList.add("active-count");
                            span.textContent = `(${activeFilterCount})`;

                            const el = document.querySelector(".swiper-container .wizzy-filters-desktop-entry");
                            if (el && !el.classList.contains("active")) {
                                el.classList.add("active");
                            }

                            const title = facetItem.querySelector(".facet-head-title");
                            if (title) {
                                const existingTitle = title.querySelector(".active-count");
                                if (!existingTitle) {
                                    title.appendChild(span);
                                }
                            }
                        }
                    })

                    if (totalActiveFilter > 0) {
                        const span = document.createElement("span");
                        span.classList.add("active-count");
                        span.textContent = ` (${totalActiveFilter})`;
                        const titleFilter = document.querySelector(".wizzy-filters-header .header-title");
                        if (titleFilter) {
                            const existingSpan = titleFilter.querySelector(".active-count");
                            if (!existingSpan) {
                                // titleFilter.appendChild(span);
                                titleFilter.appendChild(span.cloneNode(true));
                            }
                        }

                        const titleFilterMain = document.querySelector(".swiper-container .wizzy-filters-title");
                        if (titleFilterMain) {
                            const existingMainSpan = titleFilterMain.querySelector(".active-count");
                            if (!existingMainSpan) {
                                // titleFilterMain.appendChild(span);
                                titleFilterMain.appendChild(span.cloneNode(true));
                            }
                        }
                    }

                }

                //////////////////////////////////////////////////////////////////////////////////////

                const facetBlocks = document.querySelectorAll('.wizzy-search-filters-left-wrapper .wizzy-filters-facet-block');

                if (facetBlocks) {
                    facetBlocks.forEach(block => {
                        const facetList = block.querySelector('.wizzy-facet-list');
                        const listItems = facetList.querySelectorAll('li');
                        const itemsToShow = 6; // Adjust the number of items to show initially (approx 2 rows)
                        const button = block.querySelector('.toggle-button');

                        for (let i = 0; i < listItems.length; i++) {
                            if (i >= itemsToShow) {
                                listItems[i].style.display = 'none'; // Hide
                            }
                        }

                        if (listItems.length <= itemsToShow) {
                            button.style.display = 'none'; // Hide the button if not enough items
                        } else {
                            button.style.display = 'block'; // Show the button if there are enough items
                        }
                    });
                }
            }

            //////////////////////////////////////////////////////////////////////////////////////

            if (data?.data?.api === "autocomplete") {
                const products = data?.data?.response?.payload?.products;
                const query = products?.filters?.q?.toLowerCase()?.trim();

                if (!query) return;

                const suggestions = window.getQuerySuggestions(query);

                if (suggestions && suggestions.length > 0) {

                    const container = document.querySelector(".wizzy-autocomplete-custom-suggestion");

                    if (container) {
                        container.innerHTML = "";
                        suggestions.forEach(item => {

                            const suggestionHTML = `
                            <div class="suggestion-item">
                                <a href="${item.url}" target="_blank" class="suggestion-link">
                                    <img src="${item.image}" alt="${item.title}" class="suggestion-image" />
                                    <span class="suggestion-title">${item.title}</span>
                                    <span class="suggestion-title-tag">Suggested</span>
                                </a>
                            </div>
                        `;

                            container.innerHTML += suggestionHTML;
                        });
                    }
                }
            }

            // if (data?.data?.api === "autocomplete") {
            //     const products = data?.data?.response?.payload?.products;
            //     const query = products?.filters?.q?.toLowerCase()?.trim();

            //     // Get mapped collections for the query
            //     const mappedCollections = window.getQueryCollections(query);

            //     if (mappedCollections.length > 0) {
            //         const topCategoriesList = document.querySelector('.autocomplete-suggestions-list.regular-autocomplete');

            //         if (topCategoriesList) {
            //             // Find the 'Categories' head item
            //             const categoriesHead = topCategoriesList.querySelector('.autocomplete-item-head');

            //             if (categoriesHead) {
            //                 // Generate <li> elements for each mapped collection
            //                 const collectionLis = mappedCollections.map((col, index) => {
            //                     const li = document.createElement('li');
            //                     li.className = 'autocomplete-item-abc';

            //                     li.innerHTML = `
            //             <a data-selectable="true" data-searchterm="${col.title}" href="${col.url}" class="autocomplete-link-abc" data-index="${index}">
            //                 <div class="wz-searchIcon-svg">
            //                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            //                         <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="#979797" stroke-linecap="round" stroke-linejoin="round"></path>
            //                         <path d="M20.9984 20.9984L16.6484 16.6484" stroke="#979797" stroke-linecap="round" stroke-linejoin="round"></path>
            //                     </svg>
            //                 </div>
            //                 <span class="wizzy-autocomplete-label">${col.title}</span>
            //                 <span class="autocomplete-text-wrapper"></span>
            //             </a>
            //         `;
            //                     return li;
            //                 });

            //                 // Insert each new <li> just after the Categories head
            //                 collectionLis.reverse().forEach(li => {
            //                     categoriesHead.insertAdjacentElement('afterend', li);
            //                 });
            //             }
            //         }
            //     }
            // }


            //code for making sure that when only one filter option is availbe hide left pannel and make sure that product grid is getting full width
            const leftPannelFilterOptions = document.querySelectorAll(".wizzy-search-wrapper .plp_left_side.desktop .plp_sidebar_inner .wizzy-filters-facet-block.facet-block-product_sub_category_custom .wizzy-facet-body ul.wizzy-facet-list li.wizzy-facet-list-item");
            if (leftPannelFilterOptions && leftPannelFilterOptions.length <= 1) {
                const leftPannel = document.querySelector(".wizzy-search-wrapper .plp_left_side.desktop");
                const wizzySearchResultsContainer = document.querySelector(".wizzy-search-results-container");
                const wizzySearchResultsWrapper = document.querySelector(".wizzy-search-wrapper .wizzy-search-results-wrapper");
                if (leftPannel) {
                    leftPannel.style.width = "0%";
                    leftPannel.style.border = "none";

                    wizzySearchResultsWrapper.style.gap = "0";
                    wizzySearchResultsContainer.style.setProperty('width', '100%', 'important');
                }
            }

            return data;
        });
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
        function (data) {

            ////////////////////////////////////////// /////////////////////////////////////////////////
            const swiperWrapper = document.querySelector('.wz-filters-list-top-wrapper .swiper-wrapper');
            const facetBlock = document.querySelector('.wizzy-filters-facet-block[data-key="product_featured_filters_custom"]');

            if (swiperWrapper && facetBlock) {
                const clonedFacetBlock = facetBlock.cloneNode(true);
                const facetHead = clonedFacetBlock.querySelector('.wizzy-facet-head');
                if (facetHead) facetHead.remove();

                clonedFacetBlock.className
                    .split(/\s+/)          // split by whitespace
                    .filter(cls => cls)    // remove empty strings
                    .forEach(cls => swiperWrapper.classList.add(cls));

                const dataKey = clonedFacetBlock.getAttribute('data-key');
                if (dataKey) {
                    swiperWrapper.setAttribute('data-key', dataKey);
                }

                const facetItems = clonedFacetBlock.querySelectorAll('.wizzy-facet-list-item');
                swiperWrapper.innerHTML = '';
                facetItems.forEach(item => {
                    const slide = document.createElement('div');
                    slide.classList.add('swiper-slide', 'facet-slide'); // keep swiper-slide class
                    slide.appendChild(item.cloneNode(true));
                    swiperWrapper.appendChild(slide);
                });
            }
            //////////////////////////////////////////////////////////////////////////////////////////////

            const productTypeFacet = document.querySelector('.wizzy-facet-list-block .wizzy-filters-facet-block[data-key="product_sub_category_custom"]');
            const plpLeftPanel = document.querySelector('.wizzy-search-results-wrapper .plp_sidebar_inner');

            if (productTypeFacet && plpLeftPanel) {
                const clonedFacet = productTypeFacet.cloneNode(true);
                plpLeftPanel.innerHTML = ''; // Clear existing content
                plpLeftPanel.appendChild(clonedFacet); // Append the cloned facet
            }

            const plpLeftPanelMobile = document.querySelector('.wizzy-search-results-wrapper .plp_left_side.mobile .plp_sidebar_inner');
            if (productTypeFacet && plpLeftPanelMobile && document.documentElement.clientWidth < 768) {
                const clonedFacet = productTypeFacet.cloneNode(true);
                plpLeftPanelMobile.innerHTML = ''; // Clear existing content
                plpLeftPanelMobile.appendChild(clonedFacet); // Append the cloned facet
            }

            //////////////////////////////////////////////////////////////////////////////////////////////

            const filterButton = document.querySelector('.wizzy-search-filters-drawer-button.filter-btn');
            const sortButton = document.querySelector('.wizzy-search-filters-drawer-button.sort');
            const swiperWrapperNew = document.querySelector('.wz-filters-list-top-wrapper .swiper-wrapper');

            if (filterButton && sortButton && swiperWrapperNew) {
                const clonedFilterButton = filterButton.cloneNode(true);
                const clonedSortButton = sortButton.cloneNode(true);

                swiperWrapperNew.insertBefore(clonedSortButton, swiperWrapperNew.firstChild);    // Insert sort button next
                swiperWrapperNew.insertBefore(clonedFilterButton, swiperWrapperNew.firstChild);  // Insert filter button first
            }

            ensureExpressDeliveryPill(swiperWrapperNew);
            initSearchExpressDelivery(false);

            ////////////////////////////////////// //////////////////////////////////////

            document.body.classList.remove('wz-shift-footer');
            const facetItems = document.querySelectorAll('.wizzy-selected-facet-list li');
            const facetCounts = {};
            facetItems.forEach(li => {
                const key = li.getAttribute('data-facetkey');
                if (key) {
                    facetCounts[key] = (facetCounts[key] || 0) + 1;
                }
            });
            // Step 3: Select all swiper slides
            const swiperSlides = document.querySelectorAll('.swiper-slide');

            // Step 4: Match and update slides
            swiperSlides.forEach(slide => {
                const slideKey = slide.getAttribute('data-key');
                if (slideKey && facetCounts[slideKey]) {
                    slide.querySelector('.detailstop_txt').classList.add('filter_active');
                    slide.setAttribute('data-count', facetCounts[slideKey]);
                    let count_ele = slide.querySelector('.flt_count_0');
                    if (count_ele) {
                        count_ele.className = 'flt_count_' + facetCounts[slideKey];
                        count_ele.textContent = '(' + facetCounts[slideKey] + ')';
                    }
                }
            });
            let sort_options = document.querySelectorAll('.wizzy-common-select-option');
            if (sort_options) {
                sort_options.forEach((option) => {
                    option.addEventListener('click', function () {
                        document.documentElement.classList.remove('wizzy-filters-overlay');
                        document.body.classList.remove('wizzy-filters-overlay');
                    })
                })
            }
            let apply_button = document.querySelector('.wizzy-apply-all-button-block');
            if (apply_button) {
                apply_button.addEventListener('click', function () {
                    let close_btn = document.querySelector('.wizzy-filters-close-btn');
                    if (close_btn) {
                        close_btn.click();
                    }
                })
            }
            const swiperContainer = document.querySelector('.wizzy-search-wrapper .swiper-container');

            if (swiperContainer && !swiperContainer.classList.contains('swiper-initialized')) {
                new Swiper(swiperContainer, {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    freeMode: true,
                    loop: false,
                });
            }

            addTopFilterClicks();

            let veg_nveg = document.querySelector('.product_veg_non_veg_custom .plp_veg .mobile-facets__label');
            if (veg_nveg) {
                veg_nveg.addEventListener('click', handleButtonClickForVegNVeg);
            }
            let input_ele = document.querySelector('.product_veg_non_veg_custom .plp_veg .mobile-facets__checkbox');
            if (input_ele) {
                const url = new URL(window.location.href);
                if (url.searchParams.has("product_veg_non_veg_custom[]")) {
                    input_ele.setAttribute("checked", true);
                }
            }


            //////////////////////////////////////////////////////////////////////////////////////

            const allFacets = document.querySelectorAll(".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block");
            if (allFacets && allFacets.length > 0) {
                var totalActiveFilter = 0;
                allFacets.forEach(facetItem => {
                    var activeFilterCount = 0;
                    const filterItems = facetItem.querySelectorAll(".wizzy-facet-list .active");
                    if (filterItems) {
                        filterItems.forEach(item => {
                            activeFilterCount += 1;
                            totalActiveFilter += 1;
                        });
                    }

                    if (activeFilterCount > 0) {
                        const span = document.createElement("span");
                        span.classList.add("active-count");
                        span.textContent = `(${activeFilterCount})`;

                        const el = document.querySelector(".swiper-container .wizzy-filters-desktop-entry");
                        if (el && !el.classList.contains("active")) {
                            el.classList.add("active");
                        }

                        const title = facetItem.querySelector(".facet-head-title");
                        if (title) {
                            const existingTitle = title.querySelector(".active-count");
                            if (!existingTitle) {
                                title.appendChild(span);
                            }
                        }
                    }
                })

                if (totalActiveFilter > 0) {
                    const span = document.createElement("span");
                    span.classList.add("active-count");
                    span.textContent = ` (${totalActiveFilter})`;
                    const titleFilter = document.querySelector(".wizzy-filters-header .header-title");
                    if (titleFilter) {
                        const existingSpan = titleFilter.querySelector(".active-count");
                        if (!existingSpan) {
                            // titleFilter.appendChild(span);
                            titleFilter.appendChild(span.cloneNode(true));
                        }
                    }

                    const titleFilterMain = document.querySelector(".swiper-container .wizzy-filters-title");
                    if (titleFilterMain) {
                        const existingMainSpan = titleFilterMain.querySelector(".active-count");
                        if (!existingMainSpan) {
                            // titleFilterMain.appendChild(span);
                            titleFilterMain.appendChild(span.cloneNode(true));
                        }
                    }
                }

            }

            //////////////////////////////////////////////////////////////////////////////////////

            const facetBlocks = document.querySelectorAll('.wizzy-search-filters-left-wrapper .wizzy-filters-facet-block');

            if (facetBlocks) {
                facetBlocks.forEach(block => {
                    const facetList = block.querySelector('.wizzy-facet-list');
                    const listItems = facetList.querySelectorAll('li');
                    const itemsToShow = 6; // Adjust the number of items to show initially (approx 2 rows)
                    const button = block.querySelector('.toggle-button');

                    for (let i = 0; i < listItems.length; i++) {
                        if (i >= itemsToShow) {
                            listItems[i].style.display = 'none'; // Hide
                        }
                    }

                    if (listItems.length <= itemsToShow) {
                        button.style.display = 'none'; // Hide the button if not enough items
                    } else {
                        button.style.display = 'block'; // Show the button if there are enough items
                    }
                });
            }

            //////////////////////////////////////////////////////////////////////////////////////

            return data;
        });
}


////////////////////////////////////////////////////////////////////////////////////////////////////




const clearIconMobile = document.querySelector(".wz-mobile-searchbox .wz-search-bar svg.wz-autocomplete-cross-icon");
const searchInputsMobile = document.querySelectorAll(".wz-mobile-searchbox .wz-search-input");

if (clearIconMobile && searchInputsMobile.length > 0) {
    clearIconMobile.addEventListener("click", function () {
        searchInputsMobile.forEach(input => {
            input.value = '';
        });
    });
}
